import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  TemplateRef,
  Inject,
  HostListener,
} from "@angular/core";
import {
  faToggleOn,
  faToggleOff,
  faExclamationCircle,
  faExclamationTriangle,
  IconDefinition,
} from "@fortawesome/free-solid-svg-icons";
import {
  faSpinner as fasSpinner,
  faShare,
} from "@fortawesome/pro-solid-svg-icons";
import { ActivatedRoute, Router } from "@angular/router";
import { NzModalService, NzModalRef, ModalOptions } from "ng-zorro-antd/modal";
import { CompsDataService } from "../comps-data.service";
import { LineItemModalComponent } from "src/app/shared/line-item-modal/line-item-modal.component";
import {
  CompsMeta,
  CompsApiResponse,
  CompsTable,
  CompsTableColumnData,
  CompsTableRow,
  CompDetails,
  CompTypes,
  ColumnInfo,
} from "../comps-page.model";
import { DOCUMENT } from "@angular/common";
import { Observable, forkJoin, Subscription, of } from "rxjs";
import { Dictionary } from "src/app/store/models/common_types";
import { CompsTickerModalComponent } from "../comps-ticker-modal/comps-ticker-modal.component";
import { AppService } from "src/app/app.service";
import { NzMessageService } from "ng-zorro-antd/message";
import { CreateNewCompsWizardComponent } from "../create-new-comps-wizard/create-new-comps-wizard.component";
import { CommonModalService } from "src/app/shared/common-modal/common-modal.service";
import { ShareCompsTableComponent } from "../share-comps-table/share-comps-table.component";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { SetDisableActions } from "src/app/store/actions/global-subheader.actions";
import { ConvertCompsModalComponent } from "../convert-comps-modal/convert-comps-modal.component";
import { UpdateCompsData } from "src/app/store/actions/global.actions";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import {
  getSelectedPeriods,
  convertRelativePeriodIdToLabel,
  getOtherPeriods,
  getPeriodTypeDataId,
} from "src/app/utils/period-utils";
import {
  getSelectedMarketIdFromList,
  getSelectedMarketItemsList,
} from "../utils";
import {
  getNameArrAccordingToSelectedState,
  convertPeriodMetaToUserSettings,
  getIsAbsolutePeriod,
  getSelectedPeriodType,
  getSelectedPeriodBasis,
  isBasisFullYear,
  getSelectedBasisOptionId,
  ABS_PERIOD_TYPE,
} from "@va/core-library/period-filter";
import {
  MARKET_DATA_LIST,
  MONTH_DATE_ABB_YEAR_FORMAT,
  MARKETDATA_COPYRIGHT_MESSAGE,
} from "src/app/common-constants";
import { formatMCapAndEVCell } from "src/app/utils/common";
import dayjs from "dayjs";
import {
  VAIconRegistryService,
  check,
  close,
  closeCircle,
  edit,
  fileExcel,
  infoCircle,
  save,
  trash,
} from "@va/core-library/icons";
@Component({
  selector: "app-comps-page",
  templateUrl: "./comps-page.component.html",
  styleUrls: ["./comps-page.component.scss"],
  host: { class: "comps-page-component" },
})
export class CompsPageComponent implements OnInit, OnDestroy {
  compsName: string;
  faSpinner = fasSpinner;
  faShare = faShare;
  faToggleOn = faToggleOn;
  faToggleOff = faToggleOff;
  modalTitle = "Edit Line Items";
  // tabType = "va_comp";
  addColTableData: Array<any> = [];
  addRowTableData: Array<any> = [];
  watchlistData: Array<any> = [];
  tickers: Array<any> = [];
  recentlyVisitedCompanies: Array<any> = [];
  stdLineItems: Array<any> = [];
  industryId: number;
  disableUpdate: boolean;
  lineItemsModal: NzModalRef;
  convertToTimeSeriesModal: NzModalRef;
  createNewCompsModal: NzModalRef;
  shareTableModal: NzModalRef;
  tickersModal: NzModalRef;
  updated: boolean;
  compsMeta: CompsMeta;
  metaReady: boolean;
  currency: string;
  source: string;
  viewBy: Array<string>;
  revision = "";
  allSources: string[] = [];
  tickerModalDataReady = false;
  addRecentCompanies = true;
  leftModalDataReady: boolean;
  currentTab: any = {};
  compsData: Dictionary<Dictionary<any>>;
  dataReady: boolean;
  tabId: string;
  periodsWithAvailableData;
  periodsWithAvailableDataForPopup;
  mptList = {
    1: "Industrial & commercial",
    2: "Banking & Financial Services",
    3: "Insurance",
  };
  sliIds: Array<any> = [];
  showDeleteModal = false;
  exportOptVisible = false;
  inEditMode = false;
  // displayData: any = {};
  compsTableData: CompsTable = {
    rows: [],
    columns: [],
    columnData: {},
    rowData: {},
    filter: {},
    extras: {},
    title: "",
    marketColumns: [],
  };
  timeSeriesTableData: Dictionary<CompsTable> = {};
  mpt: number;
  currentTabType: string;
  selectedTab;
  timeSeriesExportType = "TimeSeries";
  selectedCompsType = "Calenderized";
  tabData;
  selectedPeriod: string;
  tabIndexToDelete;
  filterData: any = {
    allPeriods: [],
    yearType: {},
    dataView: [],
  };
  chartPopupType = "";
  chartPopupDataToUse: any = {};
  chartPopupVisible = false;
  hasUnsavedData = false;
  tabType: string;
  compType: string;
  createWatchlistData: Array<any> = [];
  loadingDocuments = false;
  fuzzySwitch: boolean;
  rowTickers: Array<string>;
  showFuzzyModal = false;
  createSource: string;
  beginningStateReferrer = "Comp Tables Page";
  apply_yoy_format = true;
  compDetails: CompDetails;
  updateMetaReady = true;
  @ViewChild("compsRename") reNameField: ElementRef;
  createCompSubscriber: Subscription;
  othercurrencies: Array<any> = [];
  getUSerCompIdSubscription: Subscription;
  globalAppSettingSubscriber: Subscription;
  tickerDeletionInProcess = false;
  getCompsMetaIsInProcess = false;
  marketDataItemCopy = []; // note: this will be same as market data that we get from meta call. we are using copy so that we can reset the market items on popup cancel/close
  marketItemsData = [].concat([...MARKET_DATA_LIST]);
  marketDataAccess = false;
  currentYear = new Date().getFullYear();
  marketDataCopyRightMessage = MARKETDATA_COPYRIGHT_MESSAGE;
  selectedLiId;

  snackBarRef: MatSnackBarRef<any>;
  // Fields used by Excel Addin page
  openedForAddIn = false;
  excelWebAppURL = "";
  peerCompanies: Array<any> = [];
  suggestedLines: Array<any> = [];
  snackbarMessage = "";
  isTickerTypeBg = false;
  MAX_TICKERS = 50;
  MAX_LINES_SINGLE_PERIOD = 50;
  MAX_LINES_TIMESERIES = 10;
  dataCallThresholdValue = 10;

  // modals
  isConvertToTimeSeriesModalVisible = false;
  isShareTableModalVisible = false;

  //subscription
  dataCallSubscription: Subscription;
  metaCallSubscription: Subscription;
  dataCallThresholdSubscription: Subscription;
  updateMetaCallSubscription: Subscription;

  // Fields used by Excel Addin page
  @HostListener("window:beforeunload", ["$event"])
  unloadNotification($event: any) {
    if (this.hasUnsavedData) {
      $event.returnValue = true;
    }
  }
  @ViewChild("successTemplate") successTemplate: TemplateRef<any>;
  @ViewChild("failureTemplate") failureTemplate: TemplateRef<any>;
  @ViewChild("infoTemplate") infoTemplate: TemplateRef<any>;

  constructor(
    protected route: ActivatedRoute,
    private modalService: NzModalService,
    private dataService: CompsDataService,
    private appService: AppService,
    private message: NzMessageService,
    private commonModalService: CommonModalService,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    public router: Router,
    private store: Store<AppState>,
    private snackBar: MatSnackBar,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([
      edit,
      save,
      fileExcel,
      trash,
      check,
      close,
      closeCircle,
      infoCircle,
    ]);
  }

  ngOnInit() {
    this.route.params.subscribe((param) => {
      this.inEditMode = false;
      this.dataService.updateLeftPanel(false);
      if (param.tabType === "current") {
        this.tabId = "current";
        this.currentTabType =
          param.tabType === "user" ? "user_comp" : "va_comp";
        this.tabType = this.currentTabType;
        const queryParams = { ...this.route.snapshot.queryParams };
        this.appService.updateLeftPanelSource.next({
          currentCompData: {
            name: queryParams.tab_name,
            params: queryParams,
            selected: true,
          },
        });
        queryParams.tickers = [].concat(queryParams.tickers);
        // const start = queryParams.period[0];
        // const end = queryParams.period[queryParams.period.length - 1];

        // const periodToSend = {};
        // periodToSend["from"] = `${start}`;
        // periodToSend["to"] = `${end}`;
        // queryParams.period = periodToSend;
        queryParams.uniquesliids = []
          .concat(queryParams.uniquesliids)
          .map((uslid) => parseInt(uslid));
        const viewBy = queryParams.view_by
          ? [].concat(queryParams.view_by)
          : ["values"];
        const dataView: { view_by: any[]; revision?: string } = {
          view_by: viewBy,
        };
        if (queryParams.revision) {
          dataView.revision = queryParams.revision;
        }
        if (queryParams.hideVsPeers) {
          // current comp when user comes with set of tickers
          const isAnnualYearSelected =
            queryParams.is_annual_selected !== undefined
              ? queryParams.is_annual_selected
              : !!(queryParams.period && queryParams.period.length);
          const compDetails: CompDetails = {
            uniquesliids: queryParams.uniquesliids,
            tickers: [].concat(queryParams.tickers),
            tab_name: queryParams.tab_name,
            period: queryParams.period
              ? [].concat(queryParams.period)
              : undefined,
            period_type: queryParams.period_type || ABS_PERIOD_TYPE.id,
            other_period: queryParams.other_period,
            is_annual_selected: isAnnualYearSelected,
            tab_type: queryParams.tab_type,
            comp_type: queryParams.comp_type,
            currency: queryParams.currency || "USD",
            source: queryParams.source || "VA Actuals/Consensus",
            dataView: dataView,
            revision: queryParams.revision || "",
          };
          if (queryParams.market_data && queryParams.market_data.length) {
            compDetails.market_data = queryParams.market_data;
          }
          this.compDetails = compDetails;
          this.initialCall(compDetails);
        } else {
          const trendPopoverPeerTickers = new Set();
          const peerCalls = [];
          queryParams.uniquesliids.forEach((uslid) => {
            peerCalls.push(
              this.dataService.getCompanyPeers(
                queryParams.tickers,
                [uslid],
                3,
                false,
              ),
            );
          });
          //special handling for CACC-3114
          forkJoin(peerCalls).subscribe((resp: any[]) => {
            for (let i = 0; i < resp.length; i++) {
              if (resp[i].status !== "error") {
                resp[i].peer_info.forEach((peer) => {
                  trendPopoverPeerTickers.add(peer.ticker);
                });
              }
            }
            const isAnnualYearSelected =
              queryParams.is_annual_selected !== undefined
                ? queryParams.is_annual_selected
                : !!(queryParams.period && queryParams.period.length);
            const compDetails: CompDetails = {
              uniquesliids: queryParams.uniquesliids,
              tickers: queryParams.tickers.concat([...trendPopoverPeerTickers]),
              tab_name: queryParams.tab_name,
              period: queryParams.period
                ? [].concat(queryParams.period)
                : undefined,
              period_type: queryParams.period_type || ABS_PERIOD_TYPE.id,
              other_period: queryParams.other_period,
              is_annual_selected: isAnnualYearSelected,
              tab_type: queryParams.tab_type,
              comp_type: queryParams.comp_type,
              currency: queryParams.currency || "USD",
              source: queryParams.source || "VA Actuals/Consensus",
              dataView: dataView,
              revision: queryParams.revision || "",
              market_data: queryParams.market_data,
            };
            this.compDetails = compDetails;
            this.initialCall(compDetails);
          });
        }
      } else {
        if (!param.tabId) {
          //let reqParams = {};
          const urlParams =
            this.route.queryParams && !this.openedForAddIn
              ? this.route.queryParams["value"]
              : {};
          // if(Object.keys(urlParams).length === 0 && urlParams.constructor === Object){
          //   reqParams['acceptedComps'] =  urlParams['accepted_comps'];
          //   reqParams['sharedId'] =  urlParams['shared_id'];
          // }
          this.getUSerCompIdSubscription = this.dataService
            .getUserCompId(urlParams)
            .subscribe((response) => {
              if (response.status === "success") {
                if (Object.keys(response.data).length === 0) {
                  if (!this.openedForAddIn) {
                    this.getTickerData();
                  }
                  this.getPeriodsForNoUserComps();
                  this.currentTabType = "user_comp";
                  this.tabType = "user_comp";
                  this.tabId = "";
                } else {
                  this.currentTabType = response.data.tab_type;
                  this.dataService.updateLeftPanel(true);
                  this.tabType = response.data.tab_type;
                  this.tabId = response.data.tab_id;
                }
                if (this.openedForAddIn) {
                  this.initialCall(null);
                } else {
                  this.router.navigate([`/comptables/user/${this.tabId}`]);
                }
                this.inEditMode = false;

                this.appService.logUserAction(
                  {},
                  "",
                  "",
                  "COMPS_SHARE_CREATED",
                  {
                    tab_id: this.tabId,
                    ...(this.openedForAddIn && { addinClientType: "addinweb" }),
                  },
                  "",
                  "COMPS_PAGE",
                );
              } else {
                if (response.status === "error" && response.data !== "") {
                  this.message.error(response.data, {
                    nzDuration: 8000,
                  });
                } else this.message.error("Something went wrong");
              }
            });
        } else {
          this.tabId = param.tabId;
          this.currentTabType =
            param.tabType === "user" ? "user_comp" : "va_comp";
          this.tabType = this.currentTabType;
          this.initialCall(null);
        }
      }
    });
    this.createCompSubscriber =
      this.appService.onGlobalSubheaderAction.subscribe(() => {
        this.createNewComp();
      });

    this.dataCallThresholdSubscription = this.dataService
      .getDataCallApiThreshold()
      .subscribe((response) => {
        this.dataCallThresholdValue = response;
      });

    this.globalAppSettingSubscriber = this.store
      .select(
        stateGetter("globalHeader", "globalAppSettings", "period_settings"),
      )
      .subscribe((data) => {
        if (data && this.metaReady) {
          //raise update of common state to trigger data calls on all tabs
          if (this.tabId && this.tabId === "current") {
            this.getCompsData(this.compDetails);
          } else {
            this.getCompsData(null);
          }
        }
      });
  }

  ngAfterViewInit() {
    if (this.reNameField) {
      this.reNameField.nativeElement.focus();
    }
  }

  getPeriodsForNoUserComps() {
    this.dataService.getPeriods().subscribe((res) => {
      if (res["status"] === "success") {
        this.filterData.allPeriods = res["period"];
      }
    });
  }

  saveNewCompTable(data) {
    let tabType = "";
    const periodSettings = convertPeriodMetaToUserSettings(data.YearTypeData);
    let yearType = null;
    let dataView = null;
    if (data.context === "Comparison") {
      tabType = "NormalComp";
      yearType = "Calendarized";
    } else {
      tabType = "TimeSeries";
      yearType = periodSettings.basis === "cal" ? "Calendarized" : "Fiscal";
      dataView = ["values", "yoy"];
    }
    const selectedMarketItems = getSelectedMarketIdFromList(
      data.marketItemsData,
    );
    this.dataService
      .saveNewComp(
        data.compsName,
        data.addRowTableData,
        data.addColTableData,
        tabType,
        periodSettings,
        yearType,
        data.currency,
        { view_by: dataView },
        !this.openedForAddIn,
        selectedMarketItems,
      )
      .subscribe((response) => {
        if (response["status"] === "success") {
          // If opend by addin, redirect it addin web url with tab id as query params
          if (this.openedForAddIn) {
            window.open(
              `${this.excelWebAppURL}comps?tabid=${
                response["tab_id"]
              }&istrends=${tabType === "TimeSeries"}&redirectedback=true`,
              "_self",
            );
            return;
          }
          this.store.dispatch(
            new UpdateCompsData({
              tabId: response["tab_id"],
              label: data.compsName,
              operation: "add",
              shortName: parseInt(response["tab_id"]),
              compType: tabType,
            }),
          );
          this.dataService.updateLeftPanel(false);
          if (this.createNewCompsModal) {
            this.createNewCompsModal.destroy();
          }
          if (this.convertToTimeSeriesModal) {
            this.isConvertToTimeSeriesModalVisible = false;
            this.convertToTimeSeriesModal.destroy();
          }
          this.router.navigate([`/comptables/user/${response["tab_id"]}`]);
          this.appService.logUserAction(
            {},
            "",
            "",
            "COMPS_CREATE_TAB",
            {
              tab_name: data.compsName,
              ticker_info: data.addRowTableData,
              line_item_info: data.addColTableData,
            },
            "",
            "COMPS_PAGE",
          );
        }
      });
  }

  openCompsCreateModalForAddinPage() {
    if (this.tickerModalDataReady) {
      const popUpProps: ModalOptions = {};
      popUpProps.nzStyle = {
        top: 0,
      };
      popUpProps.nzClosable = false;
      popUpProps.nzClassName = "create-comps-table";
      popUpProps.nzKeyboard = false;
      popUpProps.nzMaskStyle = {
        background: "#FFF",
      };
      this.createNewComp(popUpProps);
    }
  }

  createNewComp(extraPopUpProps: ModalOptions = {}) {
    const filterData = {
      allPeriods: this.filterData["allPeriods"],
      yearType: {},
    };
    this.createNewCompsModal = this.modalService.create({
      ...extraPopUpProps,
      nzTitle: "Peer Analysis Table",
      nzContent: CreateNewCompsWizardComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addRowTableData: [],
        watchlists: this.createWatchlistData,
        recentlyVisitedCompanies: this.recentlyVisitedCompanies,
        //stdLineItems: this.stdLineItems,
        addColTableData: [],
        currentIndex: 0,
        filterData: filterData,
        createSource: this.createSource,
        openedForAddIn: this.openedForAddIn,
        isTickerTypeBg: this.isTickerTypeBg,
        marketItemsData: [...MARKET_DATA_LIST].map((item) => ({
          ...item,
          checked: false,
        })),
      },
      nzWrapClassName: `comps-modal-container stepper-wizard-container peer-analysis-container ${
        !this.openedForAddIn ? "vertical-center-modal" : ""
      }`,

      nzFooter: [
        {
          label: "Restart",
          type: "default",
          onClick: (data) => {
            data.addRowTableData = [];
            data.addColTableData = [];
            data.moveToPreviousStep();
          },
          show: (data) => {
            return data.currentIndex === 1;
          },
        },
        {
          label: "Back to Company Selection",
          type: "default",
          onClick: (data) => {
            data.moveToPreviousStep();
          },
          show: (data) => {
            return data.currentIndex === 2;
          },
        },
        {
          label: "Back to Line Item Selection",
          type: "default",
          onClick: (data) => {
            data.moveToPreviousStep();
          },
          show: (data) => {
            return data.currentIndex === 3;
          },
        },
        {
          label: "Next",
          type: "primary",
          loading: (data) => data.createLiDataFetch,
          onClick: (data) => {
            data.createLiDataFetch = true;
            data.tickers = data.addRowTableData.map((data) => {
              return data.ticker;
            });
            const reqObj = {
              currency: "USD",
              tickers: data.tickers,
              show_suggested_lines: true,
            };
            forkJoin([
              this.dataService.getStdLineItems(reqObj),
              // this.dataService.getSuggestedLineItems(data.tickers)
            ]).subscribe((res) => {
              this.stdLineItems = [...res[0].data];
              data.stdLineItems = [...this.stdLineItems];
              data.createLiDataFetch = false;
              data.createSource = res[0]["default_source"];
              setTimeout(() => data.moveToNextStep(), 200);
            });
            this.appService
              .getPeriodsWithData(data.tickers)
              .subscribe((response: { status; dataAvailable }) => {
                if (response.status === "success") {
                  this.periodsWithAvailableDataForPopup =
                    response.dataAvailable;
                  data.periodsWithAvailableDataForPopup =
                    response.dataAvailable;
                }
              });
          },
          show: (data) => {
            return data.currentIndex === 1;
          },
          disabled: (data) => {
            return (
              data.addRowTableData.length < 1 ||
              data.addRowTableData.length > this.MAX_TICKERS
            );
          },
        },
        {
          label: "Next",
          type: "primary",
          onClick: (data) => {
            data.moveToNextStep();
          },
          show: (data) => {
            return data.currentIndex === 2;
          },
          disabled: (data) => {
            if (data.context === "Comparison") {
              return (
                data.addColTableData.length < 1 ||
                data.addColTableData.length > data.max
              );
            }

            return (
              data.YearTypeData === null ||
              data.addColTableData.length < 1 ||
              data.addColTableData.length > data.max
            );
          },
        },
        {
          label: "Save",
          type: "primary",
          onClick: (data) => {
            this.saveNewCompTable(data);
          },
          show: (data) => {
            return data.currentIndex === 3;
          },
          disabled: (data) => {
            return data.compsName === "";
          },
        },
      ],
    });
  }

  initialCall(compDetails: CompDetails) {
    this.metaReady = false;
    this.dataReady = false;
    this.leftModalDataReady = false;
    if (compDetails) {
      this.getCompsMeta(compDetails);
    } else {
      this.getCompsMeta(null);
    }
    if (this.othercurrencies.length === 0) {
      this.dataService.getAvailableCurrencies().subscribe((response) => {
        this.othercurrencies = response.isocurrency_list;
      });
    }
  }

  getCompsMeta(compDetails: CompDetails) {
    this.metaReady = false;
    this.store.dispatch(new SetDisableActions(true));
    const metaCall: Observable<CompsApiResponse> = compDetails
      ? this.dataService.newCompsMeta(compDetails)
      : this.dataService.getCompsMeta(
          `tab_id=${this.tabId}&tab_type=${this.tabType}`,
        );
    if (this.metaCallSubscription) {
      this.metaCallSubscription.unsubscribe();
    }
    this.metaCallSubscription = metaCall.subscribe(
      (response: CompsApiResponse) => {
        if (response.status === "error") {
          if (!this.openedForAddIn) {
            this.router.navigateByUrl("/home");
          }
          return;
        }

        if (response["msg"] && response["msg"] !== "") {
          this.message.create("error", response["msg"]);
        }

        this.marketDataAccess = response.marketdata_access;
        if (!this.marketDataAccess) {
          this.snackbarMessage =
            "You are currently not entitled to view Market/Valuation data. Please reach out to your Customer Success Manager if you require access.";
          this.snackBarRef = this.snackBar.openFromTemplate(this.infoTemplate, {
            panelClass: "info",
            duration: 5000,
            verticalPosition: "top",
          });
        }
        this.compsMeta = response.data;
        this.rowTickers = this.compsMeta.row_info.map((data) => {
          return data.ticker;
        });
        this.viewBy =
          this.compsMeta.data_view && this.compsMeta.data_view.view_by;
        this.compType = this.compsMeta.comp_type;
        // update period filters before meta mapping
        this.filterData.yearType = this.compsMeta.year_type;
        const marketItemsMetaData = [...response.data.market_data];
        this.marketDataItemCopy = marketItemsMetaData.map((item) => item.id); // copy of market item meta, which will be useful for reset
        this.marketItemsData = [...marketItemsMetaData];
        this.compsMetaMapper();
        this.tabId = this.compsMeta.tab_id
          ? this.compsMeta.tab_id.toString()
          : "current";
        this.compsName = this.compsMeta.tab_name;
        this.currentTabType = this.compsMeta.tab_type;
        // this.tabData = this.createTabData(this.compsMeta.tab_details);
        this.allSources = this.compsMeta.all_sources;
        this.addColTableData = this.compsMeta.col_info;
        this.selectedLiId = this.compsMeta.col_info.map((item) => item.sli_id);
        this.addRowTableData = this.compsMeta.row_info;
        this.mpt = this.compsMeta.mpt;
        this.currency =
          this.tabId === "current"
            ? compDetails.currency
            : this.compsMeta.tab_currency === null
              ? "Base"
              : this.compsMeta.tab_currency;
        this.source =
          this.tabId === "current" ? compDetails.source : this.compsMeta.source;
        this.viewBy =
          this.tabId === "current"
            ? compDetails.dataView["view_by"]
            : this.compsMeta.data_view && this.compsMeta.data_view["view_by"];
        this.revision =
          this.tabId === "current"
            ? compDetails.dataView["revision"] || compDetails.revision
            : this.compsMeta.data_view && this.compsMeta.data_view["revision"];
        this.filterData.allPeriods = this.compsMeta.all_periods;
        this.filterData.dataView =
          this.tabId === "current"
            ? compDetails.dataView
            : this.compsMeta.data_view;
        this.filterData.dataView.revision =
          this.tabId === "current"
            ? compDetails.revision || compDetails.dataView["revision"]
            : this.compsMeta.data_view["revision"];
        this.filterData = {
          ...this.filterData,
        };
        this.metaReady = true;
        const postObj = {
          tickers: this.rowTickers,
          show_suggested_lines: true,
        };
        if (this.currency !== "Base") {
          postObj["currency"] = this.currency;
        }
        forkJoin([
          this.dataService.getStdLineItems(postObj),
          // this.dataService.getSuggestedLineItems(this.rowTickers)
        ]).subscribe((res) => {
          this.leftModalDataReady = true;
          this.createSource = res[0].default_source;
          this.stdLineItems = [...res[0].data];
          const _suggestedLines: Array<any> = res[0].data.filter(
            (d) => d.tab_full_name === "Suggested Line Items",
          );
          this.suggestedLines = _suggestedLines.length
            ? _suggestedLines[0].tab_sli_data.map((l) => {
                return {
                  disabled: false,
                  label: l.name,
                  isLeaf: true,
                  level: 2,
                  header: false,
                  sliid: l.sli_id,
                  line_count: l.line_count,
                  id: l.uniquesliid,
                };
              })
            : [];
          if (this.suggestedLines.length > 0) {
            this.suggestedLines = [
              {
                suggestion_header: "Suggestions: ",
                isLeaf: true,
                disabled: true,
              } as any,
            ]
              .concat(this.suggestedLines)
              .concat({
                suggestion_footer: "Selected Line Items",
                isLeaf: true,
                disabled: true,
              } as any);
          } else {
            this.suggestedLines = [
              {
                suggestion_header: "No suggestion found ",
                isLeaf: true,
                disabled: true,
              } as any,
            ]
              .concat(this.suggestedLines)
              .concat({
                suggestion_footer: "Selected Line Items",
                isLeaf: true,
                disabled: true,
              } as any);
          }
        });
        this.getCompsData(compDetails);
        this.getTickerData();
        this.getPeriodsWithAvailableData(this.rowTickers);
      },
    );
  }

  getTickerData() {
    this.tickerModalDataReady = false;
    this.dataService.getWatchlists().subscribe((resp) => {
      this.watchlistData = JSON.parse(JSON.stringify(resp.data));
      this.createWatchlistData = JSON.parse(JSON.stringify(resp.data));
      const apiCalls = [this.dataService.getRecentlyVisitedCompanies()];

      const rowTickers = this.rowTickers;
      if (rowTickers && rowTickers.length) {
        const totalTickerLength = rowTickers.length || 0;
        const firstTenTickers = rowTickers.slice(0, 10);
        const firstTenTickersLength = firstTenTickers.length || 0;
        const limit = totalTickerLength - firstTenTickersLength + 10;
        apiCalls.push(
          this.dataService.getCompanyPeers(firstTenTickers, null, limit),
        );
      }
      forkJoin(apiCalls).subscribe((res) => {
        this.store.dispatch(new SetDisableActions(false));
        if (res[0] && res[0].status === "success") {
          this.recentlyVisitedCompanies = this.appService.cloneArray(
            res[0].data,
          );
        }
        const recentViewCompanies = this.recentlyVisitedCompanies.map((el) => {
          const company = {
            name: el.name,
            ticker: el.ticker,
            sli_comps_id: 0,
            mpt: el.mpt,
            isSelected: false,
          };
          return company;
        });

        if (res[1] && res[1].status === "success") {
          const responsePeers =
            (res[1].peer_info || []).reduce(function (result, item) {
              const checkIfSuggestedTickerAlreadyExists = rowTickers.includes(
                item.ticker,
              );
              if (!checkIfSuggestedTickerAlreadyExists) {
                const updatedTicker = { ...item, full_name: item.name };
                result.push(updatedTicker);
              }
              return result;
            }, []) || [];

          this.peerCompanies = responsePeers.slice(0, 10);
        }

        const recentViewCompany = {
          watchername: "Recently viewed (up to 30)",
          company_info: recentViewCompanies,
        };
        this.watchlistData.unshift(recentViewCompany);
        this.createWatchlistData.unshift(recentViewCompany);

        const peerComps = this.peerCompanies.map((pc) => {
          const company = {
            name: pc.name,
            ticker: pc.ticker,
            sli_comps_id: 0,
            mpt: pc.mpt,
            isSelected: false,
          };
          return company;
        });
        const peerData = {
          watchername: "Suggested Peers",
          company_info: peerComps,
        };
        if (peerComps && peerComps.length) {
          this.watchlistData.unshift(peerData);
        } else {
          this.watchlistData.push(peerData);
        }

        for (let i = 0; i < this.watchlistData.length; i++) {
          const parsedWatchlistData = this.watchlistData[i].company_info.map(
            (el) => {
              let company = {};

              company = {
                full_name: el.name,
                sli_comps_id: el.sli_comps_id || 0,
                ticker: el.ticker,
                mpt: el.mpt,
                isSelected: false,
              };
              el = company;
              return el;
            },
          );
          this.watchlistData[i].company_info = JSON.parse(
            JSON.stringify(parsedWatchlistData),
          );
        }

        for (let i = 1; i < this.createWatchlistData.length; i++) {
          const parsedData = this.createWatchlistData[i].company_info.map(
            (el) => {
              let company = {};
              company = {
                full_name: el.name,
                sli_comps_id: el.sli_comps_id || 0,
                ticker: el.ticker,
                mpt: el.mpt,
                isSelected: false,
              };
              el = company;
              return el;
            },
          );
          this.createWatchlistData[i].company_info = JSON.parse(
            JSON.stringify(parsedData),
          );
        }
        this.tickerModalDataReady = true;
        if (this.openedForAddIn) {
          this.openCompsCreateModalForAddinPage();
        }
      });
    });
  }

  setSelectedPeriod(param) {
    this.selectedPeriod = param;
  }

  //share Table methods
  shareTable() {
    this.isShareTableModalVisible = true;
    this.shareTableModal = this.modalService.create({
      nzTitle: "Share Peer Analysis Table",
      nzContent: ShareCompsTableComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        tabId: parseInt(this.tabId),
        componentType: "peer-analysis",
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      // nzWrapClassName: "watchlist-modal-container search-and-add-modal-container",
      nzFooter: null,
      nzOnCancel: (): void => {
        this.isShareTableModalVisible = false;
      },
    });
  }

  deleteTab(tabId, event) {
    //Need to stop propogation since clicking the close also triggers the tab click
    event.stopPropagation();
    this.showDeleteModal = true;
    this.tabIndexToDelete = tabId;
    this.showDeleteAlertModal();
  }

  deleteComps() {
    this.showDeleteModal = false;
    const deletedTabId = this.tabId;
    this.dataService.editDeleteTabDetails(this.tabId, "").subscribe(
      (res) => {
        if (res["status"] === "success") {
          const param = {};
          this.dataService.getUserCompId(param).subscribe((res) => {
            if (res.data.tab_id) {
              this.router
                .navigate([`/comptables/user/${res.data["tab_id"]}`])
                .then(() => {
                  this.store.dispatch(
                    new UpdateCompsData({
                      tabId: deletedTabId,
                      operation: "delete",
                    }),
                  );
                });
            } else {
              this.router.navigate([`/comptables/user`]).then(() => {
                this.store.dispatch(
                  new UpdateCompsData({
                    tabId: deletedTabId,
                    operation: "delete",
                  }),
                );
              });
            }
          });
          this.dataService.updateLeftPanel(false);
          this.appService.logUserAction(
            {},
            "",
            "",
            "COMPS_DELETE_TAB",
            { tab_type: "user_tabs", tab_id: this.tabId },
            "",
            "COMPS_PAGE",
          );
        }
      },
      (err) => {
        console.error(err);
      },
    );
  }

  editTabName(newName) {
    if (this.tabId === "current") {
      // this.compDetails.tab_name = this.compsName;
      // this.appService.updateLeftPanelSource.next({
      //   currentCompData: {
      //     name: this.compsName,
      //     selected: true
      //   }
      // });
      // this.hasUnsavedData = true;
      this.saveComps(false, newName);
    } else {
      this.dataService
        .editDeleteTabDetails(this.tabId, this.compsName)
        .subscribe(() => {
          // this.dataService.updateLeftPanel(true);
          this.store.dispatch(
            new UpdateCompsData({
              compId: this.tabId,
              label: this.compsName,
              operation: "update",
            }),
          );
          if (this.currentTabType !== "user_tabs") {
            this.hasUnsavedData = true;
          }
          this.appService.logUserAction(
            {},
            "",
            "",
            "COMPS_EDIT_TAB_NAME",
            {
              tab_type: "user_tabs",
              tab_id: this.tabId,
              tab_name: this.compsName,
            },
            "",
            "COMPS_PAGE",
          );
        });
    }
  }

  editTickers() {
    this.updated = false;
    this.tickersModal = this.modalService.create({
      nzTitle: "Edit Tickers",
      nzContent: CompsTickerModalComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addRowTableData: this.addRowTableData,
        watchlists: this.watchlistData,
        recentlyVisitedCompanies: this.recentlyVisitedCompanies,
        maxHeight: "340px",
        mpt: this.mpt,
        type: "edit",
        maxTickers: this.MAX_TICKERS,
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      // nzWrapClassName: "watchlist-modal-container search-and-add-modal-container",
      nzFooter: [
        {
          label: "Cancel",
          type: "default",
          onClick: (): void => {
            this.tickersModal.destroy();
          },
        },
        {
          label: "Update",
          type: "primary",
          class: "update-btn",
          onClick: (data): void => {
            this.updateTickers(data.modalData);
          },
          disabled: (data) => {
            return (
              data.modalData.length > this.MAX_TICKERS ||
              data.modalData.length === 0
            );
          },
        },
      ],
    });
  }

  UpdateCurrency(currency) {
    this.currency = currency;

    if (this.tabId === "current") {
      this.hasUnsavedData = true;

      this.dataService.getCurrencyMessage(this.currency).subscribe((res) => {
        if (res["status"] === "success") {
          const msg = res["magnitude_message"];
          this.compsMeta.magnitude_message = msg;
          if (this.compType === "TimeSeries") {
            this.sliIds.forEach((sliId) => {
              this.timeSeriesTableData[sliId].extras.magnitudeMessage = msg;
            });
          } else {
            this.compsTableData.extras.magnitudeMessage = msg;
          }
          this.compDetails.currency = this.currency;
          this.handleUpdateCurrency(this.compDetails);
        } else {
          console.error("Could not fetch magnitude message");
          this.message.error("Something went wrong");
        }
      });
      return;
    }

    this.dataService.saveCurrency(this.tabId, currency).subscribe((res) => {
      if (res.status === "success") {
        if (this.currentTabType !== "user_tabs") {
          this.hasUnsavedData = true;
        }
        this.compType === "TimeSeries"
          ? (this.timeSeriesTableData[this.sliIds[0]].extras[
              "magnitudeMessage"
            ] = res.magnitude_message)
          : (this.compsTableData.extras["magnitudeMessage"] =
              res.magnitude_message);
        this.handleUpdateCurrency(null);
        this.appService.logUserAction(
          {},
          "",
          "",
          "COMPS_UPDATE_CURRENCY",
          { user_currency: currency, tab_id: this.tabId },
          "",
          "COMPS_PAGE",
        );
      }
    }),
      (err) => {
        console.error(err);
      };
  }

  handleUpdateCurrency(compDetails: CompDetails) {
    const postObj = {
      tickers: this.rowTickers,
      show_suggested_lines: true,
    };
    if (this.currency !== "Base") postObj["currency"] = this.currency;
    this.leftModalDataReady = false;
    forkJoin([
      this.dataService.getStdLineItems(postObj),
      // this.dataService.getSuggestedLineItems(this.rowTickers)
    ]).subscribe((res) => {
      this.createSource = res[0].default_source;
      this.stdLineItems = [...res[0].data];
      this.leftModalDataReady = true;
      const _suggestedLines: Array<any> = res[0].data.filter(
        (d) => d.tab_full_name === "Suggested Line Items",
      );
      this.suggestedLines = _suggestedLines.length
        ? _suggestedLines[0].tab_sli_data.map((l) => {
            return {
              disabled: false,
              label: l.name,
              isLeaf: true,
              level: 2,
              header: false,
              sliid: l.sli_id,
              line_count: l.line_count,
              id: l.uniquesliid,
            };
          })
        : [];
      if (this.suggestedLines.length > 0) {
        this.suggestedLines = [
          {
            suggestion_header: "Suggestions: ",
            isLeaf: true,
            disabled: true,
          } as any,
        ]
          .concat(this.suggestedLines)
          .concat({
            suggestion_footer: "Selected Line Items",
            isLeaf: true,
            disabled: true,
          } as any);
      } else {
        this.suggestedLines = [
          {
            suggestion_header: "No suggestion found ",
            isLeaf: true,
            disabled: true,
          } as any,
        ]
          .concat(this.suggestedLines)
          .concat({
            suggestion_footer: "Selected Line Items",
            isLeaf: true,
            disabled: true,
          } as any);
      }
    });
    this.dataReady = false;
    this.getCompsData(compDetails);
  }

  updateSource(source) {
    this.source = source;

    if (this.tabId === "current") {
      this.hasUnsavedData = true;
      this.compsMeta.source = this.source;
      this.compDetails.source = this.source;
      this.compsMeta.col_info = this.compsMeta.col_info.map((cI) => {
        return {
          ...cI,
          source: this.source,
        };
      });
      this.getCompsData(this.compDetails);
    } else {
      const dataToSend = {
        sli_comps_id: this.sliIds,
        source: this.source,
        tab_id: this.tabId,
        period: convertPeriodMetaToUserSettings(this.filterData.yearType),
      };
      if (this.currency !== "Base") {
        dataToSend["currency"] = this.currency;
      }
      this.tickerModalDataReady = false;
      this.leftModalDataReady = false;
      if (this.updateMetaCallSubscription) {
        this.updateMetaCallSubscription.unsubscribe();
      }
      this.updateMetaReady = false;
      (this.updateMetaCallSubscription = this.dataService
        .updateCompsMeta(dataToSend)
        .subscribe((res) => {
          if (res.status === "success") {
            if (this.currentTabType !== "user_tabs") {
              this.hasUnsavedData = true;
            }
            this.compsMeta.source = this.source;
            this.compsMeta.col_info = this.compsMeta.col_info.map((item) => {
              return {
                ...item,
                source: this.source,
              };
            });
            this.getCompsData(null);
          }
          this.tickerModalDataReady = true;
          this.leftModalDataReady = true;
          this.updateMetaReady = true;
          this.appService.logUserAction(
            {},
            "",
            "",
            "COMPS_UPDATE_BROKER",
            {
              sli_comps_id: dataToSend.sli_comps_id,
              period: this.compsMeta.col_info[0].period[0],
              source: dataToSend.source,
              tab_type: this.currentTabType,
              tab_id: this.tabId,
              currency: this.currency,
            },
            "",
            "COMPS_PAGE",
          );
        })),
        (err) => {
          console.error(err);
          this.tickerModalDataReady = true;
          this.leftModalDataReady = true;
          this.updateMetaReady = true;
        };
    }
  }

  updateDataview(params) {
    this.viewBy = params.viewBy;
    this.revision = params.revision;
    // let dataViewParam = '';
    let dataView = {};
    if (params.viewBy !== "") {
      // dataViewParam += `&viewBy=${params.viewBy}`;
      dataView = { view_by: this.viewBy };
    }
    if (params.revision !== "") {
      // dataViewParam += `&revision=${params.revision}`;
      dataView = { view_by: this.viewBy, revision: params.revision };
    }

    if (this.tabId === "current") {
      this.hasUnsavedData = true;
      this.getCompsData(this.compDetails);
      this.compDetails.dataView = {
        view_by: params.viewBy,
        revision: params.revision,
      };
      this.filterData = {
        ...this.filterData,
        dataView: {
          view_by: params.viewBy,
          revision: params.revision,
        },
      };
      this.compsMeta.data_view = { ...this.compDetails.dataView };
    } else {
      //add comp type for time series
      const dataToSend = {
        period: convertPeriodMetaToUserSettings(this.filterData.yearType),
        //sli_comps_id: this.sliIds,
        // source: this.source,
        // year_type: 'CY-2020',
        tab_id: this.tabId,
        data_view: dataView,
      };

      if (this.currency !== "Base") {
        dataToSend["currency"] = this.currency;
      }
      this.tickerModalDataReady = false;
      this.leftModalDataReady = false;
      if (this.updateMetaCallSubscription) {
        this.updateMetaCallSubscription.unsubscribe();
      }
      this.updateMetaReady = false;
      this.updateMetaCallSubscription = this.dataService
        .updateCompsMeta(dataToSend)
        .subscribe(
          (res) => {
            if (res.status === "success") {
              if (this.currentTabType !== "user_tabs") {
                this.hasUnsavedData = true;
              }
              this.getCompsData(null);
              this.filterData = {
                ...this.filterData,
                dataView: {
                  view_by: params.viewBy,
                  revision: params.revision,
                },
              };
            } else {
              this.filterData = {
                ...this.filterData,
              };
            }
            this.tickerModalDataReady = true;
            this.leftModalDataReady = true;
            this.updateMetaReady = true;
            this.appService.logUserAction(
              {},
              "",
              "",
              "COMPS_UPDATE_DATA_VIEW",
              {
                tab_type: this.currentTabType,
                tab_id: this.tabId,
                view_by: params.viewBy,
                data_type: this.revision,
                currency: this.currency,
              },
              "",
              "COMPS_PAGE",
            );
          },
          (err) => {
            console.error(err);
            this.tickerModalDataReady = true;
            this.leftModalDataReady = true;
            this.updateMetaReady = true;
          },
        );
    }
  }

  updateYearType(param) {
    param = { ...param };
    if (this.tabId === "current") {
      const selectedPeriodList = getSelectedPeriods(param.updatedPeriodData);
      const otherPeriod = getNameArrAccordingToSelectedState(
        param.updatedPeriodData.other_period,
      );
      this.hasUnsavedData = true;
      this.filterData = {
        ...this.filterData,
        yearType: param.updatedPeriodData,
      };

      const periodType = getSelectedPeriodType(param.updatedPeriodData.type);
      // const start = parseInt(param.start.split("-")[1]);
      // const end = parseInt(param.end.split("-")[1]);

      // const periodToSend = {};
      // periodToSend["from"] = `${param.start.split("-")[0]}-${start}`;
      // periodToSend["to"] = `${param.end.split("-")[0]}-${end}`;

      // for (let i = start; i <= end; i++) {
      //   periodToSend.push(`${periodType}-${i}`);
      // }
      this.compDetails.period = selectedPeriodList;
      this.compDetails.period_type = periodType;
      this.compDetails.other_period = otherPeriod;
      this.compDetails.is_annual_selected =
        param.updatedPeriodData.is_annual_selected;
      this.getCompsMeta(this.compDetails);
    } else {
      const dataToSend = {
        period: param.periodUserSettingData,
        sli_comps_id: this.sliIds,
        tab_id: this.tabId,
      };

      if (this.currency !== "Base") {
        dataToSend["currency"] = this.currency;
      }
      if (this.compType === "TimeSeries") {
        // const periodSplits = dataToSend.period.split("-");
        // const periodObj = {};
        // periodObj["from"] = `${periodSplits[0]}-${periodSplits[1]}`;
        // periodObj["to"] = `${periodSplits[2]}-${periodSplits[3]}`;
        // dataToSend.period = periodObj;
        dataToSend["comp_type"] = "TimeSeries";
      } else {
        dataToSend["comp_type"] = "NormalComp";
      }
      this.tickerModalDataReady = false;
      this.leftModalDataReady = false;
      if (this.updateMetaCallSubscription) {
        this.updateMetaCallSubscription.unsubscribe();
      }
      this.updateMetaReady = false;
      this.updateMetaCallSubscription = this.dataService
        .updateCompsMeta(dataToSend)
        .subscribe(
          (res) => {
            if (res.status === "success") {
              this.filterData = {
                ...this.filterData,
                yearType: param.updatedPeriodData,
              };
              const selectedPeriodList = getSelectedPeriods(
                param.updatedPeriodData,
                false,
              );
              const otherPeriodList = getOtherPeriods(param.updatedPeriodData);
              const selectedPeriod = selectedPeriodList.concat(otherPeriodList);

              if (this.currentTabType !== "user_tabs") {
                this.hasUnsavedData = true;
              }
              this.compsMeta.col_info = this.compsMeta.col_info.map((item) => {
                return {
                  ...item,
                  period: selectedPeriod,
                };
              });
              if (this.compType === "TimeSeries") {
                this.getCompsMeta(null);
              } else {
                this.getCompsData(null);
                // this.filterData = {
                //   ...this.filterData,
                //   yearType: param.updatedPeriodData
                // };
              }
            } else {
              // this.filterData = {
              //   ...this.filterData,
              //   yearType: param.updatedPeriodData
              // };
            }
            this.tickerModalDataReady = true;
            this.leftModalDataReady = true;
            this.updateMetaReady = true;
            this.appService.logUserAction(
              {},
              "",
              "",
              "COMPS_UPDATE_PERIOD",
              {
                sli_comps_id: dataToSend.sli_comps_id,
                period: dataToSend.period,
                source: null,
                tab_type: this.currentTabType,
                tab_id: dataToSend.tab_id,
                currency: this.currency,
              },
              "",
              "COMPS_PAGE",
            );
          },
          (err) => {
            console.error(err);
            this.tickerModalDataReady = true;
            this.leftModalDataReady = true;
            this.updateMetaReady = true;
          },
        );
    }
  }

  destroyModal(): void {
    this.lineItemsModal.destroy();
  }
  destroyTickerModal(): void {
    this.tickersModal.destroy();
  }

  /**
   * Updates the suggested/peer companies
   * Selects first ten tickers and makes post api request to fetch peers, filters the response to remove already selected peers
   * @param tickers array of tickers
   */

  updatePeerCompanies(tickers: Array<string>) {
    this.tickerModalDataReady = false;
    const totalTickerLength = tickers.length || 0;
    const firstTenTickers = (tickers || []).slice(0, 10);
    const firstTenTickersLength = firstTenTickers.length || 0;
    const limit = totalTickerLength - firstTenTickersLength + 10;
    this.dataService
      .getCompanyPeers(firstTenTickers, null, limit)
      .subscribe((res) => {
        if (res && res.status === "success") {
          const peerInfo = res.peer_info || [];
          const responsePeers =
            peerInfo.reduce(function (result, item) {
              const checkIfSuggestedTickerAlreadyExists = tickers.includes(
                item.ticker,
              );
              if (!checkIfSuggestedTickerAlreadyExists) {
                const updatedTicker = { ...item, full_name: item.name };
                result.push(updatedTicker);
              }
              return result;
            }, []) || [];

          this.peerCompanies = responsePeers.slice(0, 10);

          const peerComps =
            this.peerCompanies.map((item) => {
              const company = {
                name: item.name,
                full_name: item.name,
                sli_comps_id: item.sli_comps_id || 0,
                ticker: item.ticker,
                mpt: item.mpt,
                isSelected: false,
              };
              return company;
            }) || [];

          const peerData = {
            watchername: "Suggested Peers",
            company_info: peerComps,
          };

          if (peerComps && peerComps.length) {
            if (this.watchlistData[0].watchername === "Suggested Peers") {
              this.watchlistData[0].company_info = peerComps;
              this.watchlistData = [...this.watchlistData];
            } else {
              this.watchlistData = this.watchlistData.slice(0, -1);
              this.watchlistData.unshift(peerData);
            }
          } else {
            if (this.watchlistData[0].watchername === "Suggested Peers") {
              this.watchlistData = this.watchlistData.slice(1);
              this.watchlistData.push(peerData);
            }
          }

          this.tickerModalDataReady = true;
        }
      });
  }

  updateTickers(data) {
    this.getCompsMetaIsInProcess = true;

    if (this.tabId === "current") {
      this.hasUnsavedData = true;
      this.destroyTickerModal();
      const newTickers = data.map((d) => {
        return d.ticker;
      });

      this.compDetails.tickers = newTickers;
      this.dataService
        .newCompsMeta(this.compDetails)
        .subscribe((response: CompsApiResponse) => {
          this.handleEditTickers(response, this.compDetails);
        });

      return;
    }

    const dataToSend = data.map((d) => {
      const dataObj = {};
      for (const key in d) {
        if (key !== "isSelected") {
          dataObj[key] = d[key];
        }
      }
      return dataObj;
    });
    const jsonData = {
      currency: this.currency,
      row_info: dataToSend,
      tab_id: this.tabId,
    };
    //const currency = "USD";
    this.dataService.updateTickers(jsonData).subscribe(
      () => {
        if (this.currentTabType !== "user_tabs") {
          this.hasUnsavedData = true;
        }
        this.destroyTickerModal();
        this.dataService
          .getCompsMeta(
            `tab_id=${this.tabId}&comps_type=${this.selectedCompsType}&tab_type=user_comp`,
          )
          .subscribe((response: CompsApiResponse) => {
            this.handleEditTickers(response, null);
          });
        jsonData["tab_type"] = this.currentTabType;
        this.appService.logUserAction(
          {},
          "",
          "",
          "COMPS_ADD_TICKER",
          jsonData,
          "",
          "COMPS_PAGE",
        );
      },
      (error) => {
        console.error(error);
      },
    );
  }

  handleEditTickers(response: CompsApiResponse, compDetails: CompDetails) {
    this.compsMeta = response.data;
    this.mpt = this.compsMeta.mpt;
    this.rowTickers = this.compsMeta.row_info.map((data) => {
      return data.ticker;
    });
    this.addRowTableData = this.compsMeta.row_info;

    this.updatePeerCompanies(this.rowTickers);
    this.getCompsMetaIsInProcess = false;

    this.compsMetaMapper();
    if (compDetails) {
      this.getCompsData(compDetails);
    } else {
      this.getCompsData(null);
    }

    const reqObj = {
      currency: "USD",
      tickers: this.rowTickers,
      show_suggested_lines: true,
    };
    this.leftModalDataReady = false;
    forkJoin([
      this.dataService.getStdLineItems(reqObj),
      // this.dataService.getSuggestedLineItems(this.rowTickers)
    ]).subscribe((res) => {
      this.stdLineItems = [...res[0].data];
      this.leftModalDataReady = true;
      const _suggestedLines: Array<any> = res[0].data.filter(
        (d) => d.tab_full_name === "Suggested Line Items",
      );
      this.suggestedLines = _suggestedLines.length
        ? _suggestedLines[0].tab_sli_data.map((l) => {
            return {
              disabled: false,
              label: l.name,
              isLeaf: true,
              level: 2,
              header: false,
              sliid: l.sli_id,
              line_count: l.line_count,
              id: l.uniquesliid,
            };
          })
        : [];
      if (this.suggestedLines.length > 0) {
        this.suggestedLines = [
          {
            suggestion_header: "Suggestions: ",
            isLeaf: true,
            disabled: true,
          } as any,
        ]
          .concat(this.suggestedLines)
          .concat({
            suggestion_footer: "Selected Line Items",
            isLeaf: true,
            disabled: true,
          } as any);
      } else {
        this.suggestedLines = [
          {
            suggestion_header: "No suggestion found ",
            isLeaf: true,
            disabled: true,
          } as any,
        ]
          .concat(this.suggestedLines)
          .concat({
            suggestion_footer: "Selected Line Items",
            isLeaf: true,
            disabled: true,
          } as any);
      }
    });
    this.getPeriodsWithAvailableData(this.rowTickers);
  }

  updateLineItems(data, marketItemsData) {
    if (marketItemsData) {
      this.marketItemsData = [...marketItemsData];
    }

    const selectedMarketItems = getSelectedMarketIdFromList(
      this.marketItemsData,
    );

    this.marketDataItemCopy = selectedMarketItems
      ? [...selectedMarketItems]
      : [];

    if (this.tabId === "current") {
      this.hasUnsavedData = true;
      const newLines = data.map((d) => {
        return d.sli_id;
      });
      this.compDetails.uniquesliids = newLines;
      if (selectedMarketItems && selectedMarketItems.length) {
        this.compDetails.market_data = [...selectedMarketItems];
      }
      this.destroyModal();
      this.dataService
        .newCompsMeta(this.compDetails)
        .subscribe((response: CompsApiResponse) => {
          this.handleEditLines(response, this.compDetails);
        });

      return;
    }

    const dataToSend = data.map((d) => {
      let dataObj = {};
      for (const key in d) {
        if (key !== "isSelected") {
          dataObj[key] = d[key];
        }
      }
      dataObj = {
        ...dataObj,
        period: convertPeriodMetaToUserSettings(this.filterData.yearType),
      };
      return dataObj;
    });

    this.dataService
      .updateLineItems(
        this.currency,
        this.tabId,
        dataToSend,
        selectedMarketItems,
      )
      .subscribe(
        () => {
          this.destroyModal();
          if (this.currentTabType !== "user_tabs") {
            this.hasUnsavedData = true;
          }
          this.dataService
            .getCompsMeta(
              `tab_id=${this.tabId}&comps_type=${this.selectedCompsType}&tab_type=user_comp`,
            )
            .subscribe((response: CompsApiResponse) => {
              this.handleEditLines(response, null);
            });
          this.appService.logUserAction(
            {},
            "",
            "",
            "COMPS_ADD_LINEITEMS",
            {
              tab_id: this.tabId,
              col_info: dataToSend,
              currency: this.currency,
              tab_type: this.currentTabType,
            },
            "",
            "COMPS_PAGE",
          );
        },
        (error) => {
          console.error(error);
        },
      );
  }

  handleEditLines(response: CompsApiResponse, compDetails: CompDetails) {
    this.compsMeta = response.data;
    this.rowTickers = this.compsMeta.row_info.map((data) => {
      return data.ticker;
    });
    this.addColTableData = this.compsMeta.col_info;
    this.selectedLiId = this.compsMeta.col_info.map((item) => item.sli_id);
    this.compsMetaMapper();
    if (compDetails) {
      this.getCompsData(compDetails);
    } else {
      this.getCompsData(null);
    }
  }

  editLineItems() {
    this.updated = false;
    this.lineItemsModal = this.modalService.create({
      nzTitle: this.modalTitle,
      nzOkLoading: true,
      nzContent: LineItemModalComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addColTableData: this.compsMeta.col_info,
        stdLineItems: this.stdLineItems,
        max:
          this.compType === "TimeSeries"
            ? this.MAX_LINES_TIMESERIES
            : this.MAX_LINES_SINGLE_PERIOD,
        maxHeight: "290px",
        selectedPeriod: this.compsMeta.col_info[0].period,
        tickers: this.addRowTableData.map((row) => row.ticker),
        createSource:
          this.compsMeta.source === "VA Actuals/Consensus"
            ? "vaactuals.consensus"
            : this.compsMeta.source,
        marketItemsData: [...this.marketItemsData],
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      nzFooter: [
        {
          label: "Cancel",
          type: "default",
          onClick: (): void => {
            // reset market items to last state
            this.marketItemsData = this.marketItemsData.map((item) => ({
              ...item,
              checked: this.marketDataItemCopy.includes(item.id),
            }));
            this.lineItemsModal.destroy();
          },
        },
        {
          label: "Update",
          type: "primary",
          class: "update-btn",
          nzClassName: (data) => {
            return data.modalData.length > data.max ? "disable" : "";
          },
          onClick: (data): void => {
            this.updateLineItems(data.modalData, data.marketItemsData);
            // if(this.updated)
            // this.lineItemsModal.destroy();
          },
          disabled: (data) => {
            // let disable = data.modalData.length > 50 ? true : false;
            // if(disable){
            //   document.getElementsByClassName("update-btn")? document.getElementsByClassName("update-btn")[0].setAttribute("nz-tooltip", ""):'';
            //   document.getElementsByClassName("update-btn")? document.getElementsByClassName("update-btn")[0].setAttribute("nzTooltipTitle", "exceeded"):'';
            // }
            return (
              data.modalData.length > data.max || data.modalData.length === 0
            );
          },
        },
      ],
      nzOnCancel: () => {
        // reset market items to last state
        this.marketItemsData = this.marketItemsData.map((item) => ({
          ...item,
          checked: this.marketDataItemCopy.includes(item.id),
        }));
      },
    });
  }

  handleCancel(): void {
    return;
  }

  getTabIdForSave(name?): Observable<any> {
    if (this.tabId === "current") {
      const p = convertPeriodMetaToUserSettings(this.filterData.yearType);
      const yearType = p.basis === "cal" ? "Calendarized" : "Fiscal";
      const selectedMarketItems = getSelectedMarketIdFromList(
        this.marketItemsData,
      );
      return this.dataService.saveNewComp(
        name ? name : this.compsMeta.tab_name,
        this.compsMeta.row_info,
        this.compsMeta.col_info,
        this.compType,
        p,
        yearType,
        this.currency,
        this.compsMeta.data_view,
        true,
        selectedMarketItems,
      );
    }
    return this.dataService.saveVaComps(this.tabId);
  }

  saveComps(donotNavigate?, name?) {
    let tabIdtoUpdate = this.tabId;
    this.getTabIdForSave(name).subscribe((resp) => {
      if (resp["status"] === "success") {
        if (this.tabId === "current") {
          this.tabId = resp["tab_id"];
          tabIdtoUpdate = this.tabId;
        }
        if (!donotNavigate) {
          this.router.navigate([`/comptables/user/${this.tabId}`]).then(() => {
            this.appService.updateLeftPanelSource.next({
              currentCompData: null,
            });
            this.dataService.updateLeftPanel(false);
          });
          //this.initialCall();
          this.hasUnsavedData = false;
          this.currentTabType = "user_tabs";
        } else {
          this.tabId = this.tabId.toString();
          this.appService.updateLeftPanelSource.next({
            currentCompData: null,
          });
        }

        this.store.dispatch(
          new UpdateCompsData({
            tabId: tabIdtoUpdate,
            label: name ? name : this.compsName,
            operation: "add",
            shortName: parseInt(tabIdtoUpdate, 10),
            compType: this.compType,
          }),
        );
        // this.dataService.updateLeftPanel(true);

        this.appService.logUserAction(
          {},
          "",
          "",
          "COMPS_SAVE_TO_CUSTOM_TABLE",
          {
            is_active: true,
            tab_id: tabIdtoUpdate,
            tab_type: "system_tabs",
          },
          "",
          "COMPS_PAGE",
        );
      }
    }),
      (err) => {
        console.error(err);
      };
  }

  getTabIdForExport(): Observable<any> {
    if (this.tabId === "current") {
      const p = convertPeriodMetaToUserSettings(this.filterData.yearType);
      const selectedMarketItems = getSelectedMarketIdFromList(
        this.marketItemsData,
      );
      return this.dataService.saveNewComp(
        this.compsMeta.tab_name,
        this.compsMeta.row_info,
        this.compsMeta.col_info,
        this.compType,
        p,
        this.compsMeta.comp_type,
        this.currency,
        this.compsMeta.data_view,
        false,
        selectedMarketItems,
      );
    }
    return of({ status: "success", tab_id: this.tabId });
  }

  exportValue(exportType: number) {
    this.exportOptVisible = false;
    if (exportType === 0 && this.source.toLowerCase() === "consensus+") {
      this.message.create(
        "warning",
        `Add-in formulas are not available for Consensus+ at this time.`,
      );
    } else {
      if (this.compType === "TimeSeries") {
        this.getTabIdForExport().subscribe((resp) => {
          if (resp["status"] === "success") {
            if (exportType === 0) {
              // this.message.create(
              //   "error",
              //   `Excel exports for multi period tables are not yet available. We will be adding this feature soon.`
              // );
              //#region  For export to addin
              //Allow values or yoy for excel version export
              if (
                this.viewBy.length === 1 &&
                (this.viewBy.includes("values") || this.viewBy.includes("yoy"))
              ) {
                let params = `tabid=${resp["tab_id"]}&comps_type=${this.timeSeriesExportType}&export_type=${exportType}&viewBy=${this.viewBy[0]}`;
                if (this.currency !== "Base") {
                  params = `${params}&currency=${this.currency}`;
                }
                this.downloadTrends(params, exportType);
              } else {
                //Allow values and yoy for excel version export
                if (
                  this.viewBy.length === 2 &&
                  this.viewBy.includes("values") &&
                  this.viewBy.includes("yoy")
                ) {
                  let params = `tabid=${resp["tab_id"]}&comps_type=${this.timeSeriesExportType}&export_type=${exportType}&viewBy=${this.viewBy[0]}&viewBy=${this.viewBy[1]}`;
                  if (this.currency !== "Base") {
                    params = `${params}&currency=${this.currency}`;
                  }
                  this.downloadTrends(params, exportType);
                } else {
                  this.message.create(
                    "error",
                    `Excel export is not yet available. We will be adding this feature very soon.`,
                  );
                }
              }
              //#endregion
            } else {
              //Export Value version
              if (this.viewBy.length < 2) {
                let params = `tabid=${resp["tab_id"]}&comps_type=${this.timeSeriesExportType}&export_type=${exportType}`;
                //Export Revision for values
                if (this.viewBy.length && this.viewBy.includes("revision")) {
                  params += `&viewBy=revision`;
                  if (this.revision && this.revision !== "") {
                    params += `&revision=${this.revision}`;
                  }
                } else {
                  //export value or yoy for values
                  params += `&viewBy=${this.viewBy[0]}`;
                }
                if (this.currency !== "Base") {
                  params = `${params}&currency=${this.currency}`;
                }
                this.downloadTrends(params, exportType);
              } else {
                //Allow values and yoy for value version export
                if (
                  this.viewBy.length === 2 &&
                  this.viewBy.includes("values") &&
                  this.viewBy.includes("yoy")
                ) {
                  let params = `tabid=${resp["tab_id"]}&comps_type=${this.timeSeriesExportType}&export_type=${exportType}&viewBy=${this.viewBy[0]}&viewBy=${this.viewBy[1]}`;
                  if (this.currency !== "Base") {
                    params = `${params}&currency=${this.currency}`;
                  }
                  this.downloadTrends(params, exportType);
                } else {
                  this.message.create(
                    "error",
                    `Excel export is not yet available. We will be adding this feature very soon.`,
                  );
                }
              }
            }
          } else {
            console.error("Could not generate tab id");
            this.message.error("Something went wrong");
          }
        });
      } else {
        //Export Addin version
        this.getTabIdForExport().subscribe((res) => {
          if (res["status"] === "success") {
            if (exportType === 0) {
              //Allow values or yoy for excel version export
              if (
                this.viewBy.length === 1 &&
                (this.viewBy.includes("values") || this.viewBy.includes("yoy"))
              ) {
                let params = `tabid=${res["tab_id"]}&comps_type=${this.selectedCompsType}&export_type=${exportType}&viewBy=${this.viewBy[0]}`;
                if (this.currency !== "Base") {
                  params = `${params}&currency=${this.currency}`;
                }
                this.downloadComps(params, exportType);
              } else {
                //Allow values and yoy for excel version export
                if (
                  this.viewBy.length === 2 &&
                  this.viewBy.includes("values") &&
                  this.viewBy.includes("yoy")
                ) {
                  let params = `tabid=${res["tab_id"]}&comps_type=${this.selectedCompsType}&export_type=${exportType}&viewBy=${this.viewBy[0]}&viewBy=${this.viewBy[1]}`;
                  if (this.currency !== "Base") {
                    params = `${params}&currency=${this.currency}`;
                  }
                  this.downloadComps(params, exportType);
                } else {
                  this.message.create(
                    "error",
                    `Excel export is not yet available. We will be adding this feature very soon.`,
                  );
                }
              }
            } else {
              //Export Value version
              if (this.viewBy.length < 2) {
                let params = `tabid=${this.tabId}&comps_type=${this.selectedCompsType}&export_type=${exportType}`;
                //Export Revision for values
                if (this.viewBy.length && this.viewBy.includes("revision")) {
                  params += `&viewBy=revision`;
                  if (this.revision && this.revision !== "") {
                    params += `&revision=${this.revision}`;
                  }
                } else {
                  //export value or yoy for values
                  params += `&viewBy=${this.viewBy[0]}`;
                }
                if (this.currency !== "Base") {
                  params = `${params}&currency=${this.currency}`;
                }
                this.downloadComps(params, exportType);
              } else {
                //Allow values and yoy for value version export
                if (
                  this.viewBy.length === 2 &&
                  this.viewBy.includes("values") &&
                  this.viewBy.includes("yoy")
                ) {
                  let params = `tabid=${res["tab_id"]}&comps_type=${this.selectedCompsType}&export_type=${exportType}&viewBy=${this.viewBy[0]}&viewBy=${this.viewBy[1]}`;
                  if (this.currency !== "Base") {
                    params = `${params}&currency=${this.currency}`;
                  }
                  this.downloadComps(params, exportType);
                  // this.message.create(
                  //   "error",
                  //   `Excel export for combined Values/YoY tables are not yet available. We will be adding this feature soon.`
                  // );
                } else {
                  this.message.create(
                    "error",
                    `Excel export is not yet available. We will be adding this feature very soon.`,
                  );
                }
              }
            }
          } else {
            console.error("Could not generate tab id");
            this.message.error("Something went wrong");
          }
        });
      }
    }
  }

  downloadComps(params, exportType) {
    this.loadingDocuments = true;
    params = `${params}&apply_yoy_format=${this.apply_yoy_format}`;
    const useNewAPI = true;
    this.dataService.exportComps(params, useNewAPI).subscribe(
      (res) => {
        if (res["status"] === "success") {
          const fileName = res["filename"];
          const trackerId = res["trackerid"];
          const downloadUrl = `/api/excel_file_download?exceltrackerid=${trackerId}`;
          const startIFrameTime = new Date().getTime();
          const iFrameToLoad = this._document.createElement("iframe");
          const body = this._document.getElementsByTagName("body")[0];
          iFrameToLoad.id = `${fileName}`;
          iFrameToLoad.name = `${fileName}`;
          iFrameToLoad.src = downloadUrl;
          iFrameToLoad.setAttribute("style", "visibility:hidden;display:none");
          body.appendChild(iFrameToLoad);

          const checkInterval = setInterval(() => {
            const iFrameToGet = this._document.getElementById(
              `${fileName}`,
            ) as HTMLIFrameElement;
            const iFrame =
              iFrameToGet.contentDocument || iFrameToGet.contentWindow.document;
            /*
              This check will run till the iFrame either doesn't load or for a max of 30secs
              Or till the ready state of the iFrame doesn't evaluate
            */
            if (
              iFrame.readyState === "complete" ||
              iFrame.readyState === "interactive" ||
              new Date().getTime() - startIFrameTime > 30000
            ) {
              //Commenting for now
              // this._document
              //   .getElementById(`research_download_${dataToPass.id}`)
              //   .remove();
              clearInterval(checkInterval);
              return;
            }
          }, 2000);
          this.loadingDocuments = false;
          // iframe.onload = () => {
          //   setTimeout(function() {
          //     document.getElementById(`research_download_${dataToPass.id}`).remove();
          //   }, 100);
          //   this.loading = false;
          // };

          this.appService.logUserAction(
            {},
            "",
            "",
            "COMPS_EXCEL_EXPORT",
            {
              tab_id: this.tabId,
              export_type: exportType,
              tracker_id: trackerId,
              file_name: fileName,
            },
            "",
            "COMPS_PAGE",
          );
        } else {
          this.loadingDocuments = false;
          this.message.create("error", `Export couldn't be downloaded.`);
        }
      },
      (err) => {
        this.loadingDocuments = false;
        console.error(err);
      },
    );
  }

  downloadTrends(params, exportType) {
    this.loadingDocuments = true;
    params = `${params}&apply_yoy_format=${this.apply_yoy_format}`;
    const useNewAPI = true;
    this.dataService.exportTrends(params, useNewAPI).subscribe(
      (res) => {
        if (res["status"] === "success") {
          const fileName = res["filename"];
          const trackerId = res["trackerid"];
          const downloadUrl = `/api/excel_file_download?exceltrackerid=${trackerId}`;
          const startIFrameTime = new Date().getTime();
          const iFrameToLoad = this._document.createElement("iframe");
          const body = this._document.getElementsByTagName("body")[0];
          iFrameToLoad.id = `${fileName}`;
          iFrameToLoad.name = `${fileName}`;
          iFrameToLoad.src = downloadUrl;
          iFrameToLoad.setAttribute("style", "visibility:hidden;display:none");
          body.appendChild(iFrameToLoad);

          const checkInterval = setInterval(() => {
            const iFrameToGet = this._document.getElementById(
              `${fileName}`,
            ) as HTMLIFrameElement;
            const iFrame =
              iFrameToGet.contentDocument || iFrameToGet.contentWindow.document;
            /*
              This check will run till the iFrame either doesn't load or for a max of 30secs
              Or till the ready state of the iFrame doesn't evaluate
            */
            if (
              iFrame.readyState === "complete" ||
              iFrame.readyState === "interactive" ||
              new Date().getTime() - startIFrameTime > 30000
            ) {
              //Commenting for now
              // this._document
              //   .getElementById(`research_download_${dataToPass.id}`)
              //   .remove();
              clearInterval(checkInterval);
              return;
            }
          }, 2000);
          this.loadingDocuments = false;
          // iframe.onload = () => {
          //   setTimeout(function() {
          //     document.getElementById(`research_download_${dataToPass.id}`).remove();
          //   }, 100);
          //   this.loading = false;
          // };

          this.appService.logUserAction(
            {},
            "",
            "",
            "TRENDS_EXCEL_EXPORT",
            {
              tab_id: this.tabId,
              export_type: exportType,
              tracker_id: trackerId,
              file_name: fileName,
            },
            "",
            "TIMESERIES_PAGE",
          );
        } else {
          this.loadingDocuments = false;
          this.message.create("error", `Trends export couldn't be downloaded.`);
        }
      },
      (err) => {
        this.loadingDocuments = false;
        console.error(err);
      },
    );
  }

  createDataCallUrl(compDetails) {
    const urls: Array<Observable<any>> = [];

    let _companyIds = [];
    let pointer = 0;
    _companyIds = [...this.rowTickers];

    const maxParallelCalls = this.dataCallThresholdValue;
    const companyIdChunks = [];

    for (let i = 0; i < _companyIds.length; i++) {
      if (pointer >= maxParallelCalls) {
        pointer = 0;
      }
      let arr = companyIdChunks[pointer];
      if (arr === undefined) {
        arr = [];
        arr.push(_companyIds[i]);
        companyIdChunks.push(arr);
      } else {
        arr.push(_companyIds[i]);
        companyIdChunks[pointer] = arr;
      }
      pointer++;
    }

    let viewBy = ``;
    viewBy +=
      this.viewBy[0] === "revision"
        ? `viewBy=revision&revision=${this.revision}`
        : `viewBy=${this.viewBy[0]}`;
    viewBy += this.viewBy[1] ? `&viewBy=${this.viewBy[1]}` : "";
    const marketItems = getSelectedMarketIdFromList(this.marketItemsData);

    // iteration for data call
    for (let i = 0; i < companyIdChunks.length; i++) {
      const tickerParams = this.extractTickers(companyIdChunks[i]);
      let url = `${viewBy}${tickerParams}&version=v2`;
      if (compDetails) {
        const periods = [];
        const otherPeriods = [];
        for (const item of this.compsMeta.col_info[0].period) {
          if (item === "LTM" || item === "NTM" || item === "STM") {
            otherPeriods.push(item);
          } else {
            periods.push(item);
          }
        }
        if (periods && periods.length) {
          if (compDetails.comp_type === CompTypes.timeseries) {
            url = `${url}&period=${periods.join("&period=")}`;
          } else {
            url = `${url}&period=${periods[0]}`;
          }
        }
        const _periodType = getPeriodTypeDataId(this.filterData.yearType);
        url += `&period_type=${_periodType}`;
        if (otherPeriods && otherPeriods.length) {
          url += `&other_period=${otherPeriods.join("&other_period=")}`;
        }
        if (marketItems && marketItems.length) {
          url += `&market_data=${marketItems.join("&market_data=")}`;
        }
        url = `${url}&uniquesliid=${this.sliIds.join(
          "&uniquesliid=",
        )}&source=${encodeURIComponent(this.source)}`;
      } else {
        url = `${url}&tab_id=${this.compsMeta.tab_id}`;
      }
      if (this.currency !== "Base") {
        url = `${url}&currency=${this.currency}`;
      }
      urls.push(this.dataService.getCompsData(url.trim()));
    }
    return urls;
  }

  getCompsData(compDetails: CompDetails) {
    this.dataReady = false;
    let dataCalls: Array<Observable<any>> = [];
    dataCalls = this.createDataCallUrl(compDetails);
    const marketItems = getSelectedMarketIdFromList(this.marketItemsData);

    if (this.dataCallSubscription) {
      this.dataCallSubscription.unsubscribe();
    }

    const compsTickerData = {};
    this.dataCallSubscription = forkJoin(dataCalls).subscribe(
      (reponseList) => {
        reponseList.forEach((res) => {
          if (res.status === "success") {
            // this.sliIds.push(line.sli_comps_id.toString());
            Object.keys(res.data).forEach((ticker) => {
              const tickerObj = { ...res.data[ticker] };
              if (tickerObj.market_data) {
                marketItems.forEach((item) => {
                  const currencySymbol = tickerObj.market_data[item]
                    ? tickerObj.market_data[`${item}|C`]
                    : "";
                  const rd = tickerObj.market_data[`${item}|RD`];
                  const lastDate =
                    tickerObj.market_data[item] &&
                    tickerObj.market_data[item].last_date
                      ? dayjs(tickerObj.market_data[item].last_date).format(
                          MONTH_DATE_ABB_YEAR_FORMAT,
                        )
                      : undefined;

                  const exchangeFullName = tickerObj.market_data[item]
                    ? tickerObj.market_data[item].exchange_full_name
                    : "";
                  const values = tickerObj.market_data[item]
                    ? tickerObj.market_data[item].values
                    : undefined;
                  let formattedValue = null;
                  if (values !== null && values !== undefined) {
                    formattedValue = formatMCapAndEVCell(
                      values,
                      currencySymbol,
                      "values",
                    );
                  }

                  const yoy = tickerObj.market_data[item]
                    ? tickerObj.market_data[item].yoy
                    : undefined;
                  let formattedYoy = null;
                  if (yoy !== null && yoy !== undefined) {
                    formattedYoy = formatMCapAndEVCell(
                      yoy,
                      currencySymbol,
                      "yoy",
                    );
                  }

                  const revision = tickerObj.market_data[item]
                    ? tickerObj.market_data[item].revision
                    : undefined;
                  let formattedRevision = null;
                  if (revision !== null && revision !== undefined) {
                    formattedRevision = formatMCapAndEVCell(
                      revision,
                      currencySymbol,
                      "revision",
                    );
                  }

                  tickerObj["market_data"][item] = {
                    values,
                    formattedValue,
                    yoy,
                    formattedYoy,
                    revision,
                    formattedRevision,
                    currencySymbol,
                    rd: rd,
                    currency: this.filterData.currency,
                    lastDate: lastDate,
                    exchangeFullName: exchangeFullName,
                  };
                });
              }

              if (this.compType === "TimeSeries") {
                this.compsMeta.col_info.forEach((colInfo) => {
                  (colInfo.period as Array<string>).forEach((p) => {
                    const value = tickerObj[colInfo.sli_comps_id as number]
                      ? tickerObj[colInfo.sli_comps_id as number][p]
                        ? tickerObj[colInfo.sli_comps_id as number][p].values
                        : undefined
                      : undefined;
                    if (value !== null && value !== undefined) {
                      tickerObj[colInfo.sli_comps_id as number][p][
                        "formattedValue"
                      ] = this.formatCell(
                        value,
                        tickerObj[`${colInfo.sli_comps_id}|C`],
                        colInfo.sli_comps_id,
                        "values",
                      );
                    }
                    const yoy = tickerObj[colInfo.sli_comps_id as number]
                      ? tickerObj[colInfo.sli_comps_id as number][p]
                        ? tickerObj[colInfo.sli_comps_id as number][p].yoy
                        : undefined
                      : undefined;
                    if (yoy !== null && yoy !== undefined) {
                      tickerObj[colInfo.sli_comps_id as number][p][
                        "formattedYoy"
                      ] = this.formatCell(
                        yoy,
                        tickerObj[`${colInfo.sli_comps_id}|C`],
                        colInfo.sli_comps_id,
                        "yoy",
                      );
                    }
                    const rev = tickerObj[colInfo.sli_comps_id as number]
                      ? tickerObj[colInfo.sli_comps_id as number][p]
                        ? tickerObj[colInfo.sli_comps_id as number][p].revision
                        : undefined
                      : undefined;
                    if (rev !== null && rev !== undefined) {
                      tickerObj[colInfo.sli_comps_id as number][p][
                        "formattedRev"
                      ] = this.formatCell(
                        rev,
                        tickerObj[`${colInfo.sli_comps_id}|C`],
                        colInfo.sli_comps_id,
                        "revision",
                      );
                    }
                  });
                });
              } else {
                this.compsMeta.col_info.forEach((colInfo) => {
                  const selectedPeriod = colInfo.period[0];
                  const value =
                    tickerObj[colInfo.sli_comps_id as number] &&
                    tickerObj[colInfo.sli_comps_id as number][selectedPeriod]
                      ? tickerObj[colInfo.sli_comps_id as number][
                          selectedPeriod
                        ].values
                      : undefined;
                  if (value !== null && value !== undefined) {
                    tickerObj[colInfo.sli_comps_id as number][selectedPeriod][
                      "formattedValue"
                    ] = this.formatCell(
                      value,
                      tickerObj[`${colInfo.sli_comps_id}|C`],
                      colInfo.sli_comps_id,
                      "values",
                    );
                  }
                  const yoy =
                    tickerObj[colInfo.sli_comps_id as number] &&
                    tickerObj[colInfo.sli_comps_id as number][selectedPeriod]
                      ? tickerObj[colInfo.sli_comps_id as number][
                          selectedPeriod
                        ].yoy
                      : undefined;
                  if (yoy !== null && yoy !== undefined) {
                    tickerObj[colInfo.sli_comps_id as number][selectedPeriod][
                      "formattedYoy"
                    ] = this.formatCell(
                      yoy,
                      tickerObj[`${colInfo.sli_comps_id}|C`],
                      colInfo.sli_comps_id,
                      "yoy",
                    );
                  }
                  const rev =
                    tickerObj[colInfo.sli_comps_id as number] &&
                    tickerObj[colInfo.sli_comps_id as number][selectedPeriod]
                      ? tickerObj[colInfo.sli_comps_id as number][
                          selectedPeriod
                        ].revision
                      : undefined;
                  if (rev !== null && rev !== undefined) {
                    tickerObj[colInfo.sli_comps_id as number][selectedPeriod][
                      "formattedRev"
                    ] = this.formatCell(
                      rev,
                      tickerObj[`${colInfo.sli_comps_id}|C`],
                      colInfo.sli_comps_id,
                      "revision",
                    );
                  }
                });
              }
              compsTickerData[ticker] = tickerObj;
            });
          }
        });
        if (Object.keys(compsTickerData).length === 0) {
          return;
        }

        if (this.compType === "TimeSeries") {
          Object.keys(this.timeSeriesTableData).forEach((period) => {
            this.timeSeriesTableData[period] = {
              ...this.timeSeriesTableData[period],
              rowData: compsTickerData,
              filter: {
                selectedPeriod: period,
                showValue: this.viewBy.includes("values"),
                showYoy: this.viewBy.includes("yoy"),
                showRevision: this.viewBy.includes("revision"),
                showTotal: false,
                showAverage: true,
                showMedian: true,
                revision: this.revision,
                source: this.source,
                currency: this.currency,
                periodType: getSelectedPeriodType(
                  this.filterData.yearType.type,
                ),
                basisType: getSelectedPeriodBasis(
                  this.filterData.yearType.basis,
                ),
                isAnnualYearSelected:
                  this.filterData.yearType.is_annual_selected,
              },
            };
          });
        } else {
          this.compsTableData.rowData = compsTickerData;
          this.compsTableData = {
            ...this.compsTableData,
            filter: {
              selectedPeriod: this.compsMeta.col_info[0].period[0],
              showValue: this.viewBy.includes("values"),
              showYoy: this.viewBy.includes("yoy"),
              showRevision: this.viewBy.includes("revision"),
              showTotal: false,
              showAverage: true,
              showMedian: true,
              revision: this.revision,
              source: this.source,
              currency: this.currency,
              periodType: getSelectedPeriodType(this.filterData.yearType.type),
              basisType: getSelectedPeriodBasis(this.filterData.yearType.basis),
              isAnnualYearSelected: this.filterData.yearType.is_annual_selected,
            },
          };
        }
        this.dataReady = true;
        this.appService.logUserAction(
          {},
          "",
          "",
          "COMPS_DATA",
          {
            tab_id: this.tabId,
            user_or_va_comp: this.tabType,
            comp_type: this.compType,
            view_by: this.viewBy,
            tickers: this.rowTickers,
            uniquesliids: this.compsMeta.col_info.map((data) => {
              return data.sli_id;
            }),
            source: this.source,
            period:
              this.compType === "TimeSeries"
                ? this.compsMeta.col_info[0].period
                : this.compsMeta.col_info[0].period[0],
            currency: this.currency,
            revision: this.revision,
            ...(this.openedForAddIn && { addinClientType: "addinweb" }),
          },
          "",
          "COMPS_PAGE",
        );
      },
      (err) => console.error(err),
    );
  }

  formatCell(data, currency, colSliCompId, valueType: string) {
    const sliCompsData = data;
    if (sliCompsData === undefined || sliCompsData === null) {
      return "-";
    }

    if (sliCompsData === "NM") {
      return "NM";
    }

    const valueToUse = new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(Math.abs(sliCompsData));
    let unitType = "";
    if (this.compType === "TimeSeries") {
      unitType =
        this.timeSeriesTableData[colSliCompId].columnData[
          this.timeSeriesTableData[colSliCompId].columns[0]
        ].unit;
    } else {
      unitType = this.compsTableData.columnData[colSliCompId].unit;
    }

    if (!currency || valueType === "yoy" || valueType === "revision") {
      currency = "";
    }
    if (unitType === "%") {
      unitType = valueType === "yoy" || valueType === "revision" ? "bps" : "%";
    } else {
      unitType = valueType === "yoy" || valueType === "revision" ? "%" : "";
    }
    if (sliCompsData < 0) {
      return `(${currency}${valueToUse}${unitType})`;
    }

    return `${currency}${valueToUse}${unitType}`;
  }

  extractTickers(companyids: Array<string>): string {
    let tickerParams = "";
    for (let i = 0; i < companyids.length; i++) {
      tickerParams = `${tickerParams}&ticker=${companyids[i]}`;
    }

    return tickerParams;
  }

  compsMetaMapper() {
    let compsColumnData: Dictionary<CompsTableColumnData> = {};
    let columns: Array<number | string> = [];
    const rows: Array<CompsTableRow> = this.compsMeta.row_info;
    this.sliIds = [];
    this.timeSeriesTableData = {};
    const isRelativePeriodType =
      this.filterData &&
      this.filterData.yearType &&
      !getIsAbsolutePeriod(this.filterData.yearType.type);
    const periodTypeId = isRelativePeriodType ? "rel" : "abs";
    const selectedBasisId =
      this.filterData &&
      this.filterData.yearType &&
      this.filterData.yearType.period_basis &&
      this.filterData.yearType.period_basis[periodTypeId]
        ? getSelectedBasisOptionId(
            this.filterData.yearType.period_basis[periodTypeId].from_basis,
          )
        : undefined;
    const isYearlyBasisId = isBasisFullYear(selectedBasisId);
    this.compsTableData = {
      rows: [],
      columns: [],
      marketColumns: [],
      columnData: {},
      rowData: {},
      filter: {},
      extras: {},
      title: "",
    };

    const selectedMarketItemList = getSelectedMarketItemsList(
      this.marketItemsData,
    );
    const marketColumnData = {};
    selectedMarketItemList.forEach((marketItem) => {
      const marketColumn = {
        key: marketItem.id,
        name: marketItem.label as string,
        colDisplayName: marketItem.label,
        average: {
          values: undefined,
          formattedValue: undefined,
          yoy: undefined,
          formattedYoy: undefined,
          revision: undefined,
          formattedRevision: undefined,
          currencySymbol: undefined,
          rd: undefined,
          currency: undefined,
        },
        median: {
          values: undefined,
          formattedValue: undefined,
          yoy: undefined,
          formattedYoy: undefined,
          revision: undefined,
          formattedRevision: undefined,
          currencySymbol: undefined,
          rd: undefined,
          currency: undefined,
        },
        total: {
          values: undefined,
          formattedValue: undefined,
          yoy: undefined,
          formattedYoy: undefined,
          revision: undefined,
          formattedRevision: undefined,
          currencySymbol: undefined,
          rd: undefined,
          currency: undefined,
        },
      };

      marketColumnData[marketItem.id] = marketColumn;
    });

    compsColumnData = {
      ...marketColumnData,
    };

    if (this.compType === "TimeSeries") {
      let periods: Array<string> = [];

      this.compsMeta.col_info.forEach((colInfo: ColumnInfo) => {
        this.sliIds.push(colInfo.sli_comps_id.toString());

        periods = colInfo.period as Array<string>;

        compsColumnData = {
          ...marketColumnData,
        };
        columns = [];
        let timeSeriesTableData: CompsTable = {
          rows: [],
          columns: [],
          marketColumns: [],
          columnData: {},
          rowData: {},
          filter: {},
          extras: {},
          title: "",
        };

        periods.forEach((period) => {
          const columndata: CompsTableColumnData = {
            key: period as string,
            sliId: colInfo.sli_id as number,
            sliCompsId: colInfo.sli_comps_id as number,
            name: colInfo.name as string,
            isValuationRatio: colInfo.is_valuation_ratio,
            colDisplayName: isRelativePeriodType
              ? convertRelativePeriodIdToLabel(period, isYearlyBasisId)
              : (period as string),
            isFuzzy: colInfo.fuzzysli === 1 ? true : false,
            magnitude:
              this.compsMeta.line_items_info[colInfo.sli_comps_id as number]
                .magnitude,
            unit: this.compsMeta.line_items_info[colInfo.sli_comps_id as number]
              .unit,
            average: {
              value: undefined,
              currency: undefined,
            },
            median: {
              value: undefined,
              currency: undefined,
            },
            total: {
              value: undefined,
              currency: undefined,
            },
          };
          compsColumnData[columndata.key as string] = columndata;
          columns.push(columndata.key as string);
          timeSeriesTableData = {
            rows: rows,
            columns: columns,
            marketColumns: selectedMarketItemList,
            columnData: compsColumnData,
            rowData: {},
            filter: {
              showValue: this.viewBy.includes("values"),
              showYoy: this.viewBy.includes("yoy"),
              showRevision: this.viewBy.includes("revision"),
              showTotal: false,
              showAverage: true,
              showMedian: true,
              revision: this.revision,
              source: this.source,
              currency: this.currency,
              periodType: getSelectedPeriodType(this.filterData.yearType.type),
              basisType: getSelectedPeriodBasis(this.filterData.yearType.basis),
            },
            extras: {
              magnitudeMessage: this.compsMeta.magnitude_message,
            },
            title: colInfo.name as string,
          };
        });
        this.timeSeriesTableData[`${colInfo.sli_comps_id}`] =
          timeSeriesTableData;
      });
    } else {
      this.compsMeta.col_info.forEach((colInfo) => {
        this.selectedPeriod = colInfo.period[0];
        this.sliIds.push(colInfo.sli_comps_id.toString());
        const columndata: CompsTableColumnData = {
          key: colInfo.sli_comps_id as number,
          sliId: colInfo.sli_id as number,
          sliCompsId: colInfo.sli_comps_id as number,
          name: colInfo.name as string,
          isValuationRatio: colInfo.is_valuation_ratio,
          colDisplayName: colInfo.name,
          isFuzzy: colInfo.fuzzysli === 1 ? true : false,
          magnitude:
            this.compsMeta.line_items_info[colInfo.sli_comps_id as number]
              .magnitude,
          unit: this.compsMeta.line_items_info[colInfo.sli_comps_id as number]
            .unit,
          average: {
            value: undefined,
            currency: undefined,
          },
          median: {
            value: undefined,
            currency: undefined,
          },
          total: {
            value: undefined,
            currency: undefined,
          },
        };
        compsColumnData[columndata.key as number] = columndata;
        columns.push(columndata.key);
      });
      this.compsTableData = {
        rows: rows,
        columns: columns,
        marketColumns: selectedMarketItemList,
        columnData: compsColumnData,
        rowData: {},
        filter: {
          showValue: this.viewBy.includes("values"),
          showYoy: this.viewBy.includes("yoy"),
          showRevision: this.viewBy.includes("revision"),
          showTotal: false,
          showAverage: true,
          showMedian: true,
          revision: this.revision,
          source: this.source,
          currency: this.currency,
          periodType: getSelectedPeriodType(this.filterData.yearType.type),
          basisType: getSelectedPeriodBasis(this.filterData.yearType.basis),
        },
        extras: {
          magnitudeMessage: this.compsMeta.magnitude_message,
        },
        title: "",
      };
    }
  }

  showChartPopup(chartData: Dictionary<any>) {
    const sourcesToShow = this.allSources.filter(
      (s) =>
        !s.toLowerCase().includes("va actuals") &&
        s.toLowerCase() !== "filings" &&
        s.toLowerCase() !== "consensus+",
    );
    const hasOtherPeriod = ["NTM", "LTM", "STM"].includes(
      chartData.item.period,
    );
    this.chartPopupDataToUse = {
      companyFullName: chartData.item.row.full_name,
      period: !hasOtherPeriod ? chartData.item.period : "",
      periodType: getPeriodTypeDataId(this.filterData.yearType),
      otherPeriod: hasOtherPeriod ? chartData.item.period : "",
      // source: this.source,
      sourceList: sourcesToShow.map((source) => {
        return {
          label: source,
          value: source,
          checked: source === this.source || source === "Consensus",
        };
      }),
      forecast: !chartData.item.showSurprise,
      cut: "STD",
      isPeers: false,
      gAdjust: "implied",
      dapparamId: chartData.item.dapParamId,
      ticker: chartData.item.row.ticker,
      export: true,
      selectedCurrency: this.currency,
      basisType: getSelectedPeriodBasis(this.filterData.yearType.basis),
      calendarization: true,
      isValuationRatio: chartData.item.isValuationRatio,
    };
    if (this.source !== "VA Actuals/Consensus") {
      this.chartPopupDataToUse["source"] = this.source;
    } else {
      if (this.chartPopupDataToUse.forecast) {
        this.chartPopupDataToUse["source"] = "Consensus";
      } else {
        this.chartPopupDataToUse["source"] = "VA Actuals";
      }
    }
    this.chartPopupType = chartData.chartType;
    this.chartPopupVisible = true;
  }

  hideChartPopup() {
    this.chartPopupVisible = false;
    this.chartPopupType = "";
  }

  // onChangeTicker() {
  //   if (this.currentTabType !== "user_tabs") this.hasUnsavedData = true;
  // }

  onDeleteTicker(event: any) {
    // if (event.isSnackbar !== undefined) {
    //   if (event.isSnackbar) {
    //     this.tickerModalDataReady = false;
    //     this.leftModalDataReady = false;
    //   }
    // }
    if (this.currentTabType !== "user_tabs") this.hasUnsavedData = true;
    this.tickerDeletionInProcess = true;
    const sliComIdToDelete = event.sliCompId;
    const ticker = event.ticker;
    if (this.compType === "TimeSeries") {
      this.sliIds.forEach((sliId) => {
        const newRowData = this.timeSeriesTableData[sliId].rows.filter(
          (r: CompsTableRow) => {
            return r.sli_comps_id !== sliComIdToDelete;
          },
        );
        this.timeSeriesTableData[sliId] = {
          ...this.timeSeriesTableData[sliId],
          rows: newRowData,
          extras: {
            ...this.timeSeriesTableData[sliId].extras,
            recomputeData: true,
          },
        };
      });
    }

    if (this.tabId === "current") {
      this.handleOnDeleteTicker(ticker);
      this.compDetails.tickers = this.rowTickers;
      return;
    }

    this.dataService
      .deleteTicker({
        sli_comps_id: [sliComIdToDelete],
        tab_id: this.tabId,
        is_row: true,
      })
      .subscribe(() => {
        this.handleOnDeleteTicker(ticker);
      });
  }

  handleOnDeleteTicker(ticker: string) {
    this.rowTickers = this.rowTickers.filter((rt) => rt !== ticker);
    this.addRowTableData = this.addRowTableData.filter(
      (rt) => rt.ticker !== ticker,
    );

    this.updatePeerCompanies(this.rowTickers);
    this.tickerDeletionInProcess = false;

    const reqObj = {
      currency: "USD",
      tickers: this.rowTickers,
      show_suggested_lines: true,
    };
    this.leftModalDataReady = false;
    forkJoin([
      this.dataService.getStdLineItems(reqObj),
      // this.dataService.getSuggestedLineItems(this.rowTickers)
    ]).subscribe((res) => {
      this.stdLineItems = [...res[0].data];
      this.leftModalDataReady = true;
      const _suggestedLines: Array<any> = res[0].data.filter(
        (d) => d.tab_full_name === "Suggested Line Items",
      );
      this.suggestedLines = _suggestedLines.length
        ? _suggestedLines[0].tab_sli_data.map((l) => {
            return {
              disabled: false,
              label: l.name,
              isLeaf: true,
              level: 2,
              header: false,
              sliid: l.sli_id,
              line_count: l.line_count,
              id: l.uniquesliid,
            };
          })
        : [];
      if (this.suggestedLines.length > 0) {
        this.suggestedLines = [
          {
            suggestion_header: "Suggestions: ",
            isLeaf: true,
            disabled: true,
          } as any,
        ]
          .concat(this.suggestedLines)
          .concat({
            suggestion_footer: "Selected Line Items",
            isLeaf: true,
            disabled: true,
          } as any);
      } else {
        this.suggestedLines = [
          {
            suggestion_header: "No suggestion found ",
            isLeaf: true,
            disabled: true,
          } as any,
        ]
          .concat(this.suggestedLines)
          .concat({
            suggestion_footer: "Selected Line Items",
            isLeaf: true,
            disabled: true,
          } as any);
      }
    });
    this.getPeriodsWithAvailableData(this.rowTickers);
  }

  promptToSave(nextUrl: string) {
    const title = `You're about to leave this page without saving changes.`;

    const message = `Do you want to save to Custom Tables before proceeding?`;

    let modal: NzModalRef = null;

    const primaryAction = () => {
      modal.close();
      this.saveComps(true);
      this.hasUnsavedData = false;
      this.router.navigate([nextUrl]).then(() => {
        this.dataService.updateLeftPanel(false);
      });
    };

    const notSaveAction = () => {
      modal.close();
      this.hasUnsavedData = false;
      this.router.navigate([nextUrl]);
    };

    //configure modal to show alert message
    const modalOptions = {
      title: title,
      body: message,
      accentColor: "#ee8733",
      icon: faExclamationTriangle as IconDefinition,
      actionPrimaryText: "Save",
      actionSecondaryText: "Cancel",
      actionthirdText: "Don't Save",
      onThirdClick: notSaveAction,
      onPrimaryClick: primaryAction,
      onSecondaryClick: () => {
        modal.close();
        this.dataService.updateLeftPanel(false);
      },
    };

    modal = this.commonModalService.create(modalOptions);
  }

  toggleFuzzySwitch() {
    this.fuzzySwitch = !this.fuzzySwitch;
    if (this.fuzzySwitch) {
      if (this.compType === "TimeSeries") {
        const sliCompsIds = Object.keys(this.timeSeriesTableData);
        let hasFuzzyData = false;
        for (let i = 0; i < sliCompsIds.length; i++) {
          const fuzzyCols = this.timeSeriesTableData[
            sliCompsIds[i]
          ].columns.filter((colKey) => {
            return this.timeSeriesTableData[sliCompsIds[i]].columnData[colKey]
              .isFuzzy;
          });
          if (fuzzyCols.length) {
            hasFuzzyData = true;
            break;
          }
        }
        if (!hasFuzzyData) {
          this.message.warning(
            "No best match data for this peer analysis table",
          );
        }
      } else {
        const fuzzyCols = this.compsTableData.columns.filter((colKey) => {
          return this.compsTableData.columnData[colKey].isFuzzy;
        });
        if (fuzzyCols.length === 0) {
          this.message.warning(
            "No best match data for this peer analysis table",
          );
        }
      }
    }
    this.appService.logUserAction(
      {},
      "",
      "",
      this.fuzzySwitch
        ? "COMPS_HIGHLIGHT_FUZZY_ON"
        : "COMPS_HIGHLIGHT_FUZZY_OFF",
      {
        tab_type: this.currentTabType,
        tab_id: this.tabId,
      },
      "",
      "COMPS_PAGE",
    );
  }

  convertToTimeSeries(tplTitle: TemplateRef<{}>) {
    this.isConvertToTimeSeriesModalVisible = true;
    const filterData = {
      allPeriods: this.filterData["allPeriods"],
      yearType: {},
    };
    this.convertToTimeSeriesModal = this.modalService.create({
      nzTitle: tplTitle,
      nzContent: ConvertCompsModalComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addColTableData: this.addColTableData.map((col) => {
          return {
            ...col,
            sli_comps_id: 0,
          };
        }),
        userTabId: parseInt(this.tabId),
        stdLineItems: this.stdLineItems,
        max: this.MAX_LINES_TIMESERIES,
        context: "convert",
        tickers: this.addRowTableData.map((row) => row.ticker),
        filterData: filterData,
        marketItemsData: [...this.marketItemsData],
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      nzFooter: [
        {
          label: "Cancel",
          type: "default",
          onClick: (): void => {
            this.isConvertToTimeSeriesModalVisible = false;
            this.convertToTimeSeriesModal.destroy();
          },
          show: (): boolean => {
            return true;
          },
        },
        {
          label: "Convert",
          type: "primary",
          class: "update-btn",
          onClick: (data): void => {
            if (data.compsName === "") {
              data.compsNameInvalid = true;
              return;
            }
            (data["addColTableData"] = data.addColTableData.map((col) => {
              return {
                ...col,
                source:
                  this.source === "VA Actuals/Consensus"
                    ? "vaactuals.consensus"
                    : this.source,
              };
            })),
              (data["addRowTableData"] = this.addRowTableData.map((row) => {
                return {
                  ...row,
                  mpt: this.mpt,
                  isSelected: true,
                  sli_comps_id: 0,
                };
              }));
            data["currency"] = this.currency;
            const viewObj = {
              view_by: this.filterData.dataView.view_by,
            };
            if (this.filterData.dataView.revision) {
              viewObj["revision"] = this.filterData.dataView.revision;
            }
            data["dataView"] = viewObj;
            this.saveNewCompTable(data);
            this.isConvertToTimeSeriesModalVisible = false;
          },
          show: (): boolean => {
            return true;
          },
          disabled: (data) => {
            return (
              data.addColTableData.length > this.MAX_LINES_TIMESERIES ||
              data.addColTableData.length < 1
            );
          },
        },
      ],
      nzOnCancel: (): void => {
        this.isConvertToTimeSeriesModalVisible = false;
      },
    });
  }

  setEditMode = () => {
    this.inEditMode = true;
    setTimeout(() => {
      this.reNameField.nativeElement.focus();
    }, 100);
  };

  toggleEditMode = (newName) => {
    this.inEditMode = !this.inEditMode;
    if (this.inEditMode) {
      setTimeout(() => {
        this.reNameField.nativeElement.focus();
      }, 100);
    }

    if (!this.inEditMode) {
      this.editTabName(newName);
    }
  };

  showDeleteAlertModal = (): void => {
    const title = `Delete this Peer Analysis Table?`;

    const message = `You cannot recover this table once deleted. Hit 'Delete' to proceed.`;

    let modal: NzModalRef = null;

    const primaryAction = () => {
      modal.close();
      this.deleteComps();
    };

    //configure modal to show alert message
    const modalOptions = {
      title: title,
      body: message,
      accentColor: "#ff4e33",
      icon: faExclamationCircle as IconDefinition,
      actionPrimaryText: "Delete",
      actionSecondaryText: "Cancel",
      onPrimaryClick: primaryAction,
      onSecondaryClick: () => {
        modal.close();
      },
    };

    modal = this.commonModalService.create(modalOptions);

    modal.afterClose.subscribe(() => {
      this.showDeleteModal = false;
    });
  };

  ngOnDestroy() {
    this.createCompSubscriber.unsubscribe();
    if (this.getUSerCompIdSubscription) {
      this.getUSerCompIdSubscription.unsubscribe();
    }
    if (this.globalAppSettingSubscriber) {
      this.globalAppSettingSubscriber.unsubscribe();
    }
    if (this.metaCallSubscription) {
      this.metaCallSubscription.unsubscribe();
    }
    if (this.dataCallSubscription) {
      this.dataCallSubscription.unsubscribe();
    }
    if (this.dataCallThresholdSubscription) {
      this.dataCallThresholdSubscription.unsubscribe();
    }
    if (this.updateMetaCallSubscription) {
      this.updateMetaCallSubscription.unsubscribe();
    }
  }

  onSearchTickerSelection(tickerData) {
    const { value, tickers } = tickerData;
    if (this.rowTickers.includes(value.ticker)) {
      this.snackbarMessage = "This ticker is already present.";
      this.snackBarRef = this.snackBar.openFromTemplate(this.infoTemplate, {
        panelClass: "info",
        duration: 5000,
        verticalPosition: "top",
      });
    } else {
      if (tickers.length <= this.MAX_TICKERS) {
        this.updateSearchedTicker(tickerData);
      }
    }
  }

  onSearchedLi(e) {
    this.leftModalDataReady = false;
    // const liToRemove = [...this.addColTableData];
    // this.addColTableData = [];
    const lineids = this.addColTableData.map((el) => el.sli_id);
    const period =
      this.compsMeta.col_info && this.compsMeta.col_info[0]
        ? this.compsMeta.col_info[0].period
        : this.compsMeta.col_info[0].period[0];
    const source =
      this.compsMeta.col_info && this.compsMeta.col_info[0]
        ? this.compsMeta.col_info[0].source
        : this.source;
    if (!lineids.includes(e.id)) {
      const liData = { ...e };
      liData.name = e.label;
      let lineItem = {};
      lineItem = {
        name: liData.label,
        period: period,
        sli_comps_id: 0,
        sli_id: e.id,
        uniquesliid: e.id,
        source: source,
        isSelected: true,
        line_count: e.line_count ? `${e.line_count.toString()}` : null,
      };
      // const LiData = [...this.addColTableData, lineItem];

      const LiData = this.compsMeta.col_info.concat(lineItem as ColumnInfo);

      // this.editChartLiModal.addOnScreenLi(LiData[0], liToRemove);
      lineids.push(e.id);
      if (
        lineids.length >
        (this.compType === "TimeSeries"
          ? this.MAX_LINES_TIMESERIES
          : this.MAX_LINES_SINGLE_PERIOD)
      ) {
        //Line Items overflow
        this.leftModalDataReady = true;
        return;
      }
      // const data = {
      //   chart_id: this.chartId,
      //   line_ids: lineids
      // };

      const selectedMarketItems = getSelectedMarketIdFromList(
        this.marketItemsData,
      );

      if (this.tabId === "current") {
        this.hasUnsavedData = true;
        const newLines: any[] = LiData.map((d) => {
          return d.sli_id;
        });
        this.compDetails.uniquesliids = newLines;
        this.dataService
          .newCompsMeta(this.compDetails)
          .subscribe((response: CompsApiResponse) => {
            this.handleEditLines(response, this.compDetails);
            this.leftModalDataReady = true;
            this.snackbarMessage = ` ${liData.label} has been added to the table`;
            this.snackBarRef = this.snackBar.openFromTemplate(
              this.successTemplate,
              {
                panelClass: "success",
                duration: 5000,
                verticalPosition: "top",
              },
            );
          });

        return;
      }

      const dataToSend = LiData.map((d) => {
        let dataObj = {};
        for (const key in d) {
          if (key !== "isSelected") {
            dataObj[key] = d[key];
          }
        }
        dataObj = {
          ...dataObj,
          period: convertPeriodMetaToUserSettings(this.filterData.yearType),
        };
        return dataObj;
      });
      this.dataService
        .updateLineItems(
          this.currency,
          this.tabId,
          dataToSend,
          selectedMarketItems,
        )
        .subscribe(
          () => {
            if (this.currentTabType !== "user_tabs") {
              this.hasUnsavedData = true;
              this.dataService
                .getCompsMeta(
                  `tab_id=${this.tabId}&comps_type=${this.selectedCompsType}&tab_type=user_comp`,
                )
                .subscribe((response: CompsApiResponse) => {
                  this.handleEditLines(response, null);
                  this.leftModalDataReady = true;
                });
              this.snackbarMessage = ` ${liData.label} has been added to the table`;
              this.snackBarRef = this.snackBar.openFromTemplate(
                this.successTemplate,
                {
                  panelClass: "success",
                  duration: 5000,
                  verticalPosition: "top",
                },
              );
              this.appService.logUserAction(
                {},
                "",
                "",
                "COMPS_ADD_LINEITEMS",
                {
                  tab_id: this.tabId,
                  col_info: dataToSend,
                  currency: this.currency,
                  tab_type: this.currentTabType,
                },
                "",
                "COMPS_PAGE",
              );
            } else {
              this.dataService
                .getCompsMeta(
                  `tab_id=${this.tabId}&comps_type=${this.selectedCompsType}&tab_type=user_comp`,
                )
                .subscribe((response: CompsApiResponse) => {
                  this.handleEditLines(response, null);
                  this.leftModalDataReady = true;
                });
              this.snackbarMessage = ` ${liData.label} has been added to the table`;
              this.snackBarRef = this.snackBar.openFromTemplate(
                this.successTemplate,
                {
                  panelClass: "success",
                  duration: 5000,
                  verticalPosition: "top",
                },
              );
              this.appService.logUserAction(
                {},
                "",
                "",
                "COMPS_ADD_LINEITEMS",
                {
                  tab_id: this.tabId,
                  col_info: dataToSend,
                  currency: this.currency,
                  tab_type: this.currentTabType,
                },
                "",
                "COMPS_PAGE",
              );
            }
          },
          (error) => {
            console.error(error);
          },
        );
    } else {
      this.leftModalDataReady = true;
      this.snackbarMessage = "This line item is already present.";
      this.snackBarRef = this.snackBar.openFromTemplate(this.infoTemplate, {
        panelClass: "info",
        duration: 5000,
        verticalPosition: "top",
      });
    }
  }

  updateSearchedTicker(tickerData) {
    if (tickerData.value.mpt !== this.mpt) {
      this.snackbarMessage = `Error: We currently cannot create a chart table with tickers from BOTH ${
        this.mptList[this.mpt]
      } and ${this.mptList[tickerData.value.mpt]} sectors.`;
      this.snackBarRef = this.snackBar.openFromTemplate(this.failureTemplate, {
        panelClass: "failure",
        duration: 5000,
        verticalPosition: "top",
      });
    } else {
      const company = {};
      company["name"] = tickerData.value.full_name;
      company["sli_comps_id"] = 0;
      company["ticker"] = tickerData.value.ticker;
      company["mpt"] = tickerData.value.mpt;
      company["isSelected"] = true;

      // this.isVisibleEditTickerModal = false;
      this.tickerModalDataReady = false;
      this.leftModalDataReady = false;
      const tickerDetails = this.addRowTableData.concat(company);

      if (this.tabId === "current") {
        this.hasUnsavedData = true;
        // this.destroyTickerModal();

        const newTickers = tickerDetails.map((d) => {
          return d.ticker;
        });

        this.compDetails.tickers = newTickers;
        this.dataService
          .newCompsMeta(this.compDetails)
          .subscribe((response: CompsApiResponse) => {
            this.handleEditTickers(response, this.compDetails);
            this.snackbarMessage = `${tickerData.value.full_name} has been added to the table.`;
            this.snackBarRef = this.snackBar.openFromTemplate(
              this.successTemplate,
              {
                panelClass: "success",
                duration: 5000,
                verticalPosition: "top",
              },
            );
          });

        return;
      }

      const dataToSend = tickerDetails.map((d) => {
        const dataObj = {};
        for (const key in d) {
          if (key !== "isSelected") {
            if (key === "name") {
              dataObj["full_name"] = d[key];
            } else {
              dataObj[key] = d[key];
            }
          }
        }
        return dataObj;
      });
      const jsonData = {
        currency: this.currency,
        row_info: dataToSend,
        tab_id: this.tabId,
      };
      //const currency = "USD";
      this.dataService.updateTickers(jsonData).subscribe(
        () => {
          if (this.currentTabType !== "user_tabs") {
            this.hasUnsavedData = true;
          }
          // this.destroyTickerModal();
          //add
          this.snackbarMessage = `${tickerData.value.full_name} has been added to the table.`;
          this.snackBarRef = this.snackBar.openFromTemplate(
            this.successTemplate,
            {
              panelClass: "success",
              duration: 5000,
              verticalPosition: "top",
            },
          );
          this.dataService
            .getCompsMeta(
              `tab_id=${this.tabId}&comps_type=${this.selectedCompsType}&tab_type=user_comp`,
            )
            .subscribe((response: CompsApiResponse) => {
              this.handleEditTickers(response, null);
              this.tickerModalDataReady = true;
              this.leftModalDataReady = true;
            });
          jsonData["tab_type"] = this.currentTabType;
          // this.updatePeerCompanies(this.rowTickers);
          this.appService.logUserAction(
            {},
            "",
            "",
            "COMPS_ADD_TICKER",
            jsonData,
            "",
            "COMPS_PAGE",
          );
        },
        (error) => {
          console.error(error);
        },
      );
      //   const tickers = tickerData.tickers;
      //   // const data = {
      //   //   chart_name: this.chartName,
      //   //   chart_id: this.chartId,
      //   //   tickers
      //   // };
      //   // if (this.chartId === "suggested" || this.chartId === "current") {
      //   //   this.hasUnsavedData = true;
      //   //   this.updateSelectedTickerData(tickers, company);
      //   // } else {
      //   //   this.dataService.updateCharts(data).subscribe((res) => {
      //   //     if (res["status"] === "success") {
      //   //       this.updateSelectedTickerData(tickers, company);
      //   //     }
      //   //   });
      //   // }
      //   // this.chartsMetaRaw["ticker_info"] = tickerData;
      //   // this.chartsMeta.filters.tickers = tickerData.map((tInfo) => {
      //   //   return {
      //   //     name: tInfo.name,
      //   //     ticker: tInfo.ticker
      //   //   };
      //   // });
      //   this.rowTickers = tickerData.tickers;
      //   // this.addRowTableData = tickerData;
      //   //this.mpt = this.mpt; //need to get mpt from BE in update response
      //   const postObj = {
      //     tickers: this.rowTickers,
      //     show_suggested_lines: true
      //   };
      //   this.dataService.getStdLineItems(postObj).subscribe((res) => {
      //     this.leftModalDataReady = true;
      //     this.stdLineItems = [...res.data];
      //     const _suggestedLines: Array<any> = res.data.filter(
      //       (d) => d.tab_full_name === "Suggested Line Items"
      //     );
      //     this.suggestedLines = _suggestedLines.length
      //       ? _suggestedLines[0].tab_sli_data.map((l) => {
      //           return {
      //             disabled: false,
      //             label: l.name,
      //             isLeaf: true,
      //             level: 2,
      //             header: false,
      //             sliid: l.sli_id,
      //             line_count: l.line_count,
      //             id: l.uniquesliid
      //           };
      //         })
      //       : [];
      //     if (this.suggestedLines.length > 0) {
      //       this.suggestedLines = [
      //         {
      //           suggestion_header: "Suggestions: ",
      //           isLeaf: true,
      //           disabled: true
      //         } as any
      //       ].concat(this.suggestedLines);
      //     } else {
      //       this.suggestedLines = [
      //         {
      //           suggestion_header: "No suggestion found ",
      //           isLeaf: true,
      //           disabled: true
      //         } as any
      //       ].concat(this.suggestedLines);
      //     }
      //   });
      //   this.dataService
      //     .getCompanyPeers(this.rowTickers, null)
      //     .subscribe((res) => {
      //       if (res.status === "success") {
      //         this.peerCompanies = this.appService
      //           .cloneArray(res.peer_info)
      //           .map((item) => ({ ...item, full_name: item.name }));
      //         if (this.peerCompanies.length) {
      //           const peerComps = this.peerCompanies.map((pc) => {
      //             const company = {
      //               name: pc.name,
      //               ticker: pc.ticker,
      //               sli_comps_id: 0,
      //               mpt: pc.mpt,
      //               isSelected: false
      //             };
      //             return company;
      //           });
      //           if (this.watchlistData[0].watchername === "Suggested Peers") {
      //             this.watchlistData[0].company_info = peerComps;
      //             this.watchlistData = [...this.watchlistData];
      //           } else {
      //             this.watchlistData = this.watchlistData.slice(0, -1);
      //             this.watchlistData.unshift({
      //               watchername: "Suggested Peers",
      //               company_info: peerComps
      //             });
      //           }
      //         } else {
      //           if (this.watchlistData[0].watchername === "Suggested Peers") {
      //             this.watchlistData = this.watchlistData.slice(1);
      //             this.watchlistData.push({
      //               watchername: "Suggested Peers",
      //               company_info: []
      //             });
      //           }
      //         }
      //       }
      //       this.tickerModalDataReady = true;
      //     });
    }
  }

  dismissSnackBar() {
    this.snackBarRef.dismiss();
  }

  getPeriodsWithAvailableData(tickerIds) {
    this.appService
      .getPeriodsWithData(tickerIds)
      .subscribe((response: { status; dataAvailable }) => {
        if (response.status === "success") {
          this.periodsWithAvailableData = response.dataAvailable;
        }
      });
  }
}
